export const RESOURCE: any = {
    SignOut: "MyK_Label_Profile_SignOut",
    Profile: "MyK_Label_Profile_Profile",
    FooterVersion: "MyK_Footer_Version",
    FooterCopyright: "MyK_Footer_Copyright",
    UnauthroizedUser: "MyK_Info_UnauthroizedUser",
    UnauthroizedUserErrorMsg: "MyK_Error_UnauthroizedUserErrorMsg",
    MyK_Label_OwnedBy: "MyK_Label_OwnedBy",
    MyK_Label_BelongingTo: "MyK_Label_BelongingTo",
    MyK_Label_CurrentlyLocatedAt: "MyK_Label_CurrentlyLocatedAt",
    MyK_Label_Serial: "MyK_Label_Serial",
    MyK_Label_EventTime: "MyK_Label_EventTime",
    MyK_Label_LastSMR: "MyK_Label_LastSMR",
    MyK_Label_Unit: "MyK_Label_Unit",
    MyK_Label_Model: "MyK_Label_Model",
    MyK_Label_SerialPerUnit: "MyK_Label_SerialPerUnit",
    MyK_Label_ManufacturerName: "MyK_Label_ManufacturerName",
    MyK_Label_SMR: "MyK_Label_SMR",
    MyK_Label_Flags: "MyK_Label_Flags",
    MyK_Label_FCCount: "MyK_Label_FCCount",
    MyK_Label_WorkingHours: "MyK_Label_WorkingHours",
    MyK_Label_Fuel: "MyK_Label_Fuel",
    MYK_Label_DEF_Remaining: "MyK_Label_DEF_Remaining",
    MyK_Label_Idle: "MyK_Label_Idle",
    MyK_Label_IdleTime: "MyK_Label_IdleTime",
    MyK_Label_SMRDate: "MyK_Label_SMRDate",
    MyK_Label_GeneralAttributes: "MyK_Label_GeneralAttributes",
    MyK_Label_TerritoryDistributor: "MyK_Label_TerritoryDistributor",
    MyK_Label_CustomerInformation: "MyK_Label_CustomerInformation",
    MyK_Label_ComunicationType: "MyK_Label_ComunicationType",
    MyK_Label_PowerSavingMode: "MyK_Label_PowerSavingMode",
    MyK_Label_DeliveryDate: "MyK_Label_DeliveryDate",
    MyK_Label_LastCommunicationDate: "MyK_Label_LastCommunicationDate",
    MyK_Label_MachineDetails: "MyK_Label_MachineDetails",
    MyK_Label_MyLocation: "MyK_Label_MyLocation",
    MyK_Label_MyHealth: "MyK_Label_MyHealth",
    MyK_Label_MyCoverage: "MyK_Label_MyCoverage",
    MyK_Label_MyProductivity: "MyK_Label_MyProductivity",
    MyK_Label_MyTier4: "MyK_Label_MyTier4",
    MyK_Label_Reporting: "MyK_Label_Reporting",
    MyK_Label_IMC: "MyK_Label_IMC",
    MyK_Label_GeneralSpecificationDocuments: "MyK_Label_GeneralSpecificationDocuments",
    MyK_Label_LastViewDocument: "MyK_Label_LastViewDocument",
    MyK_Label_ExportToExcel: "MyK_Label_ExportToExcel",
    MyK_Label_ExportExcel: "MyK_Label_ExportExcel",
    MyK_Label_HybridView: "MyK_Label_HybridView",
    MyK_Label_GridView: "MyK_Label_GridView",
    MyK_Label_MapView: "MyK_Label_MapView",
    MyK_Label_GraphicalView: "MyK_Label_GraphicalView",
    MyK_Label_MyUtilization: "MyK_Label_MyUtilization",
    MyK_Label_Event: "MyK_Label_Event",
    MyK_Label_TransmitTime: "MyK_Label_TransmitTime",
    MyK_Label_Latitude: "MyK_Label_Latitude",
    MyK_Label_Longitude: "MyK_Label_Longitude",
    MyK_Label_Altitude: "MyK_Label_Altitude",
    MyK_Label_Engine: "MyK_Label_Engine",
    MyK_Label_UnitInstallationDate: "Unit Installation Date",
    MyK_Label_OperatorandMaintenance: "MyK_Label_OperatorandMaintenance",
    MyK_Label_OMManualsFound: "MyK_Label_OMManualsFound",
    MyK_Label_PartsandServiceNews: "MyK_Label_PartsandServiceNews",
    MyK_Label_PartsandServiceNewsDocsFound: "MyK_Label_PartsandServiceNewsDocsFound",
    MyK_Label_ShopManual: "MyK_Label_ShopManual",
    MyK_Label_ShopManualsFound: "MyK_Label_ShopManualsFound",
    MyK_Label_ChartNoData: "MyK_Label_ChartNoData",
    MyK_Label_SuggestedMachine: "MyK_Label_SuggestedMachine",
    MyK_Label_NoMachineFound: "MyK_Label_NoMachineFound",
    MyK_Label_SearchPlaceholder: "MyK_Label_SearchPlaceholder",
    MyK_Label_Reference: "MyK_Label_Reference",
    MyK_Label_Description: "MyK_Label_Description",
    MyK_Label_DocumentType: "MyK_Label_DocumentType",
    MyK_Label_LanguageText: "MyK_Label_LanguageText",
    MyK_Label_PSNNumber: "MyK_Label_PSNNumber",
    MyK_Label_IssueDateText: "MyK_Label_IssueDateText",
    MyK_Label_ManualsTab: "MyK_Label_ManualsTab",
    MyK_Label_FactoryCampaignTab: "MyK_Label_FactoryCampaignTab",
    MyK_Label_EngineonStatus: "MyK_Label_EngineonStatus",
    MyK_Label_EngineHours: "MyK_Label_EngineHours",
    MyK_Label_WorkingHoursHeader: "MyK_Label_WorkingHoursHeader",
    MyK_Label_WaterTemp: "MyK_Label_WaterTemp",
    MyK_Label_NoOperationRecord: "MyK_Label_NoOperationRecord",
    MyK_Label_AvgFuel: "MyK_Label_AvgFuel",
    MyK_Label_AverageFuel: "MyK_Label_AverageFuel",
    MyK_Label_AvgFuelDutyCycle: "MyK_Label_AvgFuelDutyCycle",
    MyK_Label_EngineOilTemp: "MyK_Label_EngineOilTemp",
    MyK_Label_EngineCoolantTemp: "MyK_Label_EngineCoolantTemp",
    MyK_Label_OperationStatusHistory: "MyK_Label_OperationStatusHistory",
    MyK_Label_OperationStatusDate: "MyK_Label_OperationStatusDate",
    MyK_Label_DateText: "MyK_Label_DateText",
    MyK_Label_FullAcceTravelHours: "MyK_Label_FullAcceTravelHours",
    MyK_Label_SNo: "MyK_Label_SNo",
    MyK_Label_AllDistributors: "MyK_Label_AllDistributors",
    MyK_Label_AllCustomers: "MyK_Label_AllCustomers",
    MyK_Label_AllLocations: "MyK_Label_AllLocations",
    MyK_Menu_MyFleet: "MyK_Menu_MyFleet",
    MyK_Label_Location: "MyK_Label_Location",
    MyK_Label_Customer_Account: "MyK_Label_Customer_Account",
    MyK_Label_Customer_Name: "MyK_Label_Customer_Name",
    MyK_Label_GeneralDocumentNoText: "MyK_Label_GeneralDocumentNoText",
    MyK_Label_NoRecordsAvailable: "MyK_Label_NoRecordsAvailable",
    MyK_Label_MachineLocation: "MyK_Label_MachineLocation",
    MyK_Label_ViewHistory: "MyK_Label_ViewHistory",
    MyK_PreFooter_FleetManagement: "MyK_PreFooter_FleetManagement",
    MyK_PreFooter_Parts: "MyK_PreFooter_Parts",
    MyK_PreFooter_Parts_ShoppingCart: "MyK_PreFooter_Parts_ShoppingCart",
    MyK_Header_CustomerSupport: "MyK_Header_CustomerSupport",
    MyK_Header_Notifications: "MyK_Header_Notifications",
    MyK_Header_Promotions: "MyK_Header_Promotions",
    MyK_Header_FleetPerformance: "MyK_Header_FleetPerformance",
    MyK_Header_GeneralDetails: "MyK_Header_GeneralDetails",
    MyK_DatePicker_Today: "MyK_DatePicker_Today",
    MyK_DatePicker_Yesterday: "MyK_DatePicker_Yesterday",
    MyK_DatePicker_Last7Days: "MyK_DatePicker_Last7Days",
    MyK_DatePicker_Last30Days: "MyK_DatePicker_Last30Days",
    MyK_DatePicker_ThisMonth: "MyK_DatePicker_ThisMonth",
    MyK_DatePicker_LastMonth: "MyK_DatePicker_LastMonth",
    MyK_Grid_ItemsPerPage: "MyK_Grid_ItemsPerPage",
    MyK_Grid_Items: "MyK_Grid_Items",
    MyK_Grid_GoFirstPage: "MyK_Grid_GoFirstPage",
    MyK_Grid_GoPreviousPage: "MyK_Grid_GoPreviousPage",
    MyK_Grid_GoNextPage: "MyK_Grid_GoNextPage",
    MyK_Grid_GoLastPage: "MyK_Grid_GoLastPage",
    MyK_Grid_AbnormalityCode: "MyK_Grid_AbnormalityCode",
    MyK_Grid_Description: "MyK_Grid_Description",
    MyK_Grid_Ambient_Air_Temperature: "MyK_Grid_Ambient_Air_Temperature",
    MyK_Grid_Ambient_Air_Temperature_Unit_Of_Measure:
        "MyK_Grid_Ambient_Air_Temperature_Unit_Of_Measure",
    MyK_Grid_Description_Of_Code_Source: "MyK_Grid_Description_Of_Code_Source",
    MyK_Grid_CodeSeverity: "MyK_Grid_CodeSeverity",
    MyK_Grid_OnMonitor: "MyK_Grid_OnMonitor",
    MyK_Grid_ActionLevel: "MyK_Grid_ActionLevel",
    MyK_Grid_FleetAbnormalityType: "MyK_Grid_FleetAbnormalityType",
    MyK_Grid_Component: "MyK_Grid_Component",
    MyK_Grid_InstanceNo: "MyK_Grid_InstanceNo",
    MyK_Grid_LastOccured: "MyK_Grid_LastOccured",
    MyK_Grid_AbnormalitySMR: "MyK_Grid_AbnormalitySMR",
    MyK_Grid_AbnormalityFreq: "MyK_Grid_AbnormalityFreq",
    MyK_Grid_MinAfterEngineStart: "MyK_Grid_MinAfterEngineStart",
    MyK_Grid_ServCallRecom: "MyK_Grid_ServCallRecom",
    MyK_Grid_RecommendedBy: "MyK_Grid_RecommendedBy",
    MyK_Grid_Manufacturer: "MyK_Grid_Manufacturer",
    MyK_Grid_Parts_Number: "MyK_Grid_Parts_Number",
    MyK_Grid_Part_Description: "MyK_Grid_Part_Description",
    MyK_Grid_Recommendation_Parts: "MyK_Grid_Recommendation_Parts",
    MyK_Grid_Qty: "MyK_Grid_Qty",
    MyK_Label_Item: "MyK_Label_Item",
    MyK_Label_SettledInterval: "MyK_Label_SettledInterval",
    MyK_Label_LastMaintenance: "MyK_Label_LastMaintenance",
    MyK_Label_SMRLastMaintenance: "MyK_Label_SMRLastMaintenance",
    MyK_Label_HourstoNextMaintenance: "MyK_Label_HourstoNextMaintenance",
    MyK_Label_CautionDate: "MyK_Label_CautionDate",
    MyK_Label_CautionType: "MyK_Label_CautionType",
    MyK_Label_CautionDetails: "MyK_Label_CautionDetails",
    MyK_Label_TimeOfCaution: "MyK_Label_TimeOfCaution",
    MyK_Label_CountOfMins: "MyK_Label_CountOfMins",
    MyK_Label_Daily: "MyK_Label_Daily",
    MyK_Label_Monthly: "MyK_Label_Monthly",
    MyK_Label_Weekly: "MyK_Label_Weekly",
    MyK_Label_UtilizationNote: "MyK_Label_UtilizationNote",
    MyK_ChartLabel_Hours: "MyK_ChartLabel_Hours",
    MyK_ChartLabel_DistanceHours: "MyK_ChartLabel_DistanceHours",
    MyK_ChartLabel_ModeHours: "MyK_ChartLabel_ModeHours",
    MyK_ChartLabel_FuelUsed: "MyK_ChartLabel_FuelUsed",
    MyK_UtilGrid_MonthDateYear: "MyK_UtilGrid_MonthDateYear",
    MyK_UtilGrid_MonthYear: "MyK_UtilGrid_MonthYear",
    MyK_UtilGrid_SMR: "MyK_UtilGrid_SMR",
    MyK_UtilGrid_EngineHours: "MyK_UtilGrid_EngineHours",
    MyK_Label_ManufName: "MyK_Label_ManufName",
    MyK_HealthLabel_Maintenance: "MyK_HealthLabel_Maintenance",
    MyK_HealthLabel_Cautions: "MyK_HealthLabel_Cautions",
    MyK_Grid_ServiceIntervalHours: "MyK_Grid_ServiceIntervalHours",
    MyK_Label_Abnormalities: "MyK_Label_Abnormalities",
    MyK_UtilGrid_WorkingHours: "MyK_UtilGrid_WorkingHours",
    MyK_UtilGrid_IdleHours: "MyK_UtilGrid_IdleHours",
    MyK_UtilGrid_ATTUsageHours: "MyK_UtilGrid_ATTUsageHours",
    MyK_UtilGrid_TravelHours: "MyK_UtilGrid_TravelHours",
    MyK_UtilGrid_DiggingHours: "MyK_UtilGrid_DiggingHours",
    MyK_UtilGrid_HoistHours: "MyK_UtilGrid_HoistHours",
    MyK_UtilGrid_BreakerUsageHours: "MyK_UtilGrid_BreakerUsageHours",
    MyK_UtilGrid_TravelingHours: "MyK_UtilGrid_TravelingHours",
    MyK_UtilGrid_SwingonlyHours: "MyK_UtilGrid_SwingonlyHours",
    MyK_UtilGrid_BladeRipperWorkingHours: "MyK_UtilGrid_BladeRipperWorkingHours",
    MyK_UtilGrid_AutomaticShiftingHours: "MyK_UtilGrid_AutomaticShiftingHours",
    MyK_UtilGrid_DozingHours: "MyK_UtilGrid_DozingHours",
    MyK_UtilGrid_RippingHours: "MyK_UtilGrid_RippingHours",
    MyK_UtilGrid_SteeringHours: "MyK_UtilGrid_SteeringHours",
    MyK_UtilGrid_PumpLoadHours: "MyK_UtilGrid_PumpLoadHours",
    MyK_UtilGrid_OrangeZoneHours: "MyK_UtilGrid_OrangeZoneHours",
    MyK_UtilGrid_AutoDiggingSelectedHours: "MyK_UtilGrid_AutoDiggingSelectedHours",
    MyK_UtilGrid_HSTReliefHours: "MyK_UtilGrid_HSTReliefHours",
    MyK_UtilGrid_RunningHoursthrottle: "MyK_UtilGrid_RunningHoursthrottle",
    MyK_UtilGrid_TCRunningHoursF1: "MyK_UtilGrid_TCRunningHoursF1",
    MyK_UtilGrid_TCRunningHoursF2: "MyK_UtilGrid_TCRunningHoursF2",
    MyK_UtilGrid_TCSWorkingHours: "MyK_UtilGrid_TCSWorkingHours",
    MyK_UtilGrid_RetarderUsageHours: "MyK_UtilGrid_RetarderUsageHours",
    MyK_UtilGrid_InchingUsageHours: "MyK_UtilGrid_InchingUsageHours",
    MyK_UtilGrid_TCModeUsageHours: "MyK_UtilGrid_TCModeUsageHours",
    MyK_UtilGrid_SuperLowSpeedHours: "MyK_UtilGrid_SuperLowSpeedHours",
    MyK_UtilGrid_DifflockHours: "MyK_UtilGrid_DifflockHours",
    MyK_UtilGrid_FWDOperationHours: "MyK_UtilGrid_FWDOperationHours",
    MyK_UtilGrid_CreepingHours: "MyK_UtilGrid_CreepingHours",
    MyK_UtilGrid_WaitingforDriveHours: "MyK_UtilGrid_WaitingforDriveHours",
    MyK_UtilGrid_WaitingBHHours: "MyK_UtilGrid_WaitingBHHours",
    MyK_UtilGrid_PowerModeHours: "MyK_UtilGrid_PowerModeHours",
    MyK_UtilGrid_LoadHandlingHours: "MyK_UtilGrid_LoadHandlingHours",
    MyK_UtilGrid_NormalChargingHours: "MyK_UtilGrid_NormalChargingHours",
    MyK_UtilGrid_EqualizedChargingHours: "MyK_UtilGrid_EqualizedChargingHours",
    MyK_UtilGrid_NormalFastChargingHours: "MyK_UtilGrid_NormalFastChargingHours",
    MyK_UtilGrid_OpportunityChargingHours: "MyK_UtilGrid_OpportunityChargingHours",
    MyK_UtilGrid_RefreshChargingHours: "MyK_UtilGrid_RefreshChargingHours",
    MyK_UtilGrid_TotalFuelConsumption: "MyK_UtilGrid_TotalFuelConsumption",
    MyK_UtilGrid_FuelRate: "MyK_UtilGrid_FuelRate",
    MyK_UtilGrid_FuelConsActualWorking: "MyK_UtilGrid_FuelConsActualWorking",
    MyK_UtilGrid_AdBlueDEFConsumption: "MyK_UtilGrid_AdBlueDEFConsumption",
    MyK_UtilGrid_VeryLightModeHours: "MyK_UtilGrid_VeryLightModeHours",
    MyK_UtilGrid_LightModeHours: "MyK_UtilGrid_LightModeHours",
    MyK_UtilGrid_HeavyModeHours: "MyK_UtilGrid_HeavyModeHours",
    MyK_UtilGrid_VeryHeavyModeHours: "MyK_UtilGrid_VeryHeavyModeHours",
    MyK_UtilGrid_PowerMode: "MyK_UtilGrid_PowerMode",
    MyK_UtilGrid_EcoMode: "MyK_UtilGrid_EcoMode",
    MyK_UtilGrid_AveragePumpPreDurDigging: "MyK_UtilGrid_AveragePumpPreDurDigging",
    MyK_UtilGrid_PassingFrequencyCount: "MyK_UtilGrid_PassingFrequencyCount",
    MyK_UtilGrid_AveragePumpPressure: "MyK_UtilGrid_AveragePumpPressure",
    MyK_UtilGrid_Switchingfrequencycount: "MyK_UtilGrid_Switchingfrequencycount",
    MyK_UtilGrid_TotalPayload: "MyK_UtilGrid_TotalPayload",
    MyK_UtilGrid_CycleCount: "MyK_UtilGrid_CycleCount",
    MyK_UtilGrid_AveragePayload: "MyK_UtilGrid_AveragePayload",
    MyK_UtilGrid_OverLoadCount: "MyK_UtilGrid_OverLoadCount",
    MyK_UtilGrid_TCSOperationCount: "MyK_UtilGrid_TCSOperationCount",
    MyK_UtilGrid_LifterLockOpeCount: "MyK_UtilGrid_LifterLockOpeCount",
    MyK_UtilGrid_AverageFWDOilPressure: "MyK_UtilGrid_AverageFWDOilPressure",
    MyK_UtilGrid_DifflockOperationCount: "MyK_UtilGrid_DifflockOperationCount",
    MyK_UtilGrid_AvgFrontEngineFuel: "MyK_UtilGrid_AvgFrontEngineFuel",
    MyK_UtilGrid_AvgFuel: "MyK_UtilGrid_AvgFuel",
    MyK_UtilGrid_AvgRearFuel: "MyK_UtilGrid_AvgRearFuel",
    MyK_UtilGrid_OperationTime: "MyK_UtilGrid_OperationTime",
    MyK_UtilGrid_DozingTime: "MyK_UtilGrid_DozingTime",
    MyK_GoDashboard: "MyK_GoDashboard",
    MyK_ProdLabel_Miles: "MyK_ProdLabel_Miles",
    MyK_ProdLabel_MilesCycle: "MyK_ProdLabel_MilesCycle",
    MyK_ProdLabel_KM: "MyK_ProdLabel_KM",
    MyK_ProdLabel_KMCycle: "MyK_ProdLabel_KMCycle",
    MyK_ProdLabel_Percentage: "MyK_ProdLabel_Percentage",
    MyK_ProdLabel_HaulDistance: "MyK_ProdLabel_HaulDistance",
    MyK_Label_PartsBook: "MyK_Label_PartsBook",
    MyK_Label_ExportPDF: "MyK_Label_ExportPDF",
    MyK_Label_RegenerationTime: "MyK_Label_RegenerationTime",
    MyK_Label_Caution: "MyK_Label_Caution",
    //MyK_Label_EngineHours: "",
    MyK_Label_RegenerationCount: "MyK_Label_RegenerationCount",
    MyK_Label_EventHours: "MyK_Label_EventHours",
    MyK_Label_RegenerationCountTimes: "MyK_Label_RegenerationCountTimes",
    MyK_Label_Required: "MyK_Label_Required",
    //MyK_Label_Caution: "MyK_Label_Caution",
    MyK_Label_Divided: "MyK_Label_Divided",
    MyK_Label_Stopped: "MyK_Label_Stopped",
    MyK_Label_Completed: "MyK_Label_Completed",
    MyK_Label_RegenerationReason: "MyK_Label_RegenerationReason",
    MyK_Label_RegenerationTimeMin: "MyK_Label_RegenerationTimeMin",
    MyK_Label_RegenerationTimeStartEnd: "MyK_Label_RegenerationTimeStartEnd",
    MyK_Label_AfterTreatmentDeviceMaintenanceRecord:
        "MyK_Label_AfterTreatmentDeviceMaintenanceRecord",
    MyK_Label_KDOCheatingefficiency: "MyK_Label_KDOCheatingefficiency",
    MyK_Label_FuelDoserCurrentEfficiency: "MyK_Label_FuelDoserCurrentEfficiency",
    MyK_Label_RegenerationHistory: "MyK_Label_RegenerationHistory",
    MyK_Label_StartTime: "MyK_Label_StartTime",
    MyK_Label_EndTime: "MyK_Label_EndTime",
    MyK_Label_ListView: "MyK_Label_ListView",
    MyK_Productivity_ProductivityHeader: "MyK_Productivity_ProductivityHeader",
    MyK_Productivity_AvgNetPayload: "MyK_Productivity_AvgNetPayload",
    MyK_Productivity_TotalNetWeightMoved: "MyK_Productivity_TotalNetWeightMoved",
    MyK_Productivity_TimePeriod: "MyK_Productivity_TimePeriod",
    MyK_Productivity_DaysWithNoReportedPayloads: "MyK_Productivity_DaysWithNoReportedPayloads",
    MyK_Productivity_NetDays: "MyK_Productivity_NetDays",
    MyK_Productivity_AvgWeightMovedPerDay: "MyK_Productivity_AvgWeightMovedPerDay",
    MyK_Productivity_AvgWeightMovedPerNetDay: "MyK_Productivity_AvgWeightMovedPerNetDay",
    MyK_Productivity_AvgSwingloadsPerCycle: "MyK_Productivity_AvgSwingloadsPerCycle",
    MyK_Productivity_AvgWeightPerSwingload: "MyK_Productivity_AvgWeightPerSwingload",
    MyK_Productivity_AvgCarrybackPerCycle: "MyK_Productivity_AvgCarrybackPerCycle",
    MyK_Productivity_MaxSpeedLoaded: "MyK_Productivity_MaxSpeedLoaded",
    MyK_Productivity_GrossPayload: "MyK_Productivity_GrossPayload",
    MyK_Productivity_OfRatedPL: "MyK_Productivity_OfRatedPL",
    MyK_Productivity_AvgMaxSpeedLoaded: "MyK_Productivity_AvgMaxSpeedLoaded",
    MyK_Productivity_MaxSpeedEmpty: "MyK_Productivity_MaxSpeedEmpty",
    MyK_Productivity_AvgMaxSpeedEmpty: "MyK_Productivity_AvgMaxSpeedEmpty",
    MyK_Productivity_CriticalStatusFlags: "MyK_Productivity_CriticalStatusFlags",
    MyK_Productivity_DateFrom: "MyK_Productivity_DateFrom",
    MyK_Productivity_DateTo: "MyK_Productivity_DateTo",
    MyK_Productivity_Cycles: "MyK_Productivity_Cycles",
    MyK_Productivity_InvalidCycles: "MyK_Productivity_InvalidCycles",
    MyK_Productivity_TotalLoad: "MyK_Productivity_TotalLoad",
    MyK_Productivity_AvgLoad: "MyK_Productivity_AvgLoad",
    MyK_Productivity_LoadStdDev: "MyK_Productivity_LoadStdDev",
    MyK_Productivity_Overloaded: "MyK_Productivity_Overloaded",
    MyK_Productivity_Overload110: "MyK_Productivity_Overload110",
    MyK_Productivity_Overload120: "MyK_Productivity_Overload120",
    MyK_Productivity_MaxLoaderRecorded: "MyK_Productivity_MaxLoaderRecorded",
    MyK_Productivity_EmptyMaxSpeed: "MyK_Productivity_EmptyMaxSpeed",
    MyK_Productivity_EmptyAVGSpeed: "MyK_Productivity_EmptyAVGSpeed",
    MyK_Productivity_LoadedMaxSpeed: "MyK_Productivity_LoadedMaxSpeed",
    MyK_Productivity_LoadedAVGSpeed: "MyK_Productivity_LoadedAVGSpeed",
    MyK_Productivity_MaxSprungLoad: "MyK_Productivity_MaxSprungLoad",
    MyK_Productivity_AvgMaxSprungLoad: "MyK_Productivity_AvgMaxSprungLoad",
    MyK_Productivity_MaxTorque: "MyK_Productivity_MaxTorque",
    MyK_Productivity_AvgMaxTorque: "MyK_Productivity_AvgMaxTorque",
    MyK_Productivity_RightFrontTireWear: "MyK_Productivity_RightFrontTireWear",
    MyK_Productivity_LeftFrontTireWear: "MyK_Productivity_LeftFrontTireWear",
    MyK_Productivity_RearTires: "MyK_Productivity_RearTires",
    MyK_Productivity_RASMeasurementinMicrofails: "MyK_Productivity_RASMeasurementinMicrofails",
    MyK_Productivity_Haulcycles: "MyK_Productivity_Haulcycles",
    MyK_Productivity_TotalPayLoad: "MyK_Productivity_TotalPayLoad",
    MyK_Productivity_AvgPayLoad: "MyK_Productivity_AvgPayLoad",
    MyK_Productivity_Overload: "MyK_Productivity_Overload",
    MyK_Productivity_EmptyStopTime: "MyK_Productivity_EmptyStopTime",
    MyK_Productivity_EmptyTravelDistance: "MyK_Productivity_EmptyTravelDistance",
    MyK_Productivity_EmptyTravelTime: "MyK_Productivity_EmptyTravelTime",
    MyK_Productivity_LoadingStopTime: "MyK_Productivity_LoadingStopTime",
    MyK_Productivity_LoadedTravelDistance: "MyK_Productivity_LoadedTravelDistance",
    MyK_Productivity_LoadedTravelTime: "MyK_Productivity_LoadedTravelTime",
    MyK_Productivity_LimitedSpeed: "MyK_Productivity_LimitedSpeed",
    MyK_Productivity_SpeedLimitExceeded: "MyK_Productivity_SpeedLimitExceeded",
    Myk_Productivity_DailyLogPMOTrucks: "Myk_Productivity_DailyLogPMOTrucks",
    Myk_Productivity_DailyLogHDTrucks: "Myk_Productivity_DailyLogHDTrucks",
    Myk_Productivity_DailyLogSummarizedData: "Myk_Productivity_DailyLogSummarizedData",
    MyK_Label_ItemsPerPage: "MyK_Label_ItemsPerPage",
    MyK_Trend_From: "MyK_Trend_From",
    MyK_Trend_To: "MyK_Trend_To",
    MyK_Trend_Avg: "MyK_Trend_Avg",
    MyK_Trend_Compare_To_Fleet: "MyK_Trend_Compare_To_Fleet",
    MyK_Trend_Average: "MyK_Trend_Average",
    MyK_Trend_Minimum: "MyK_Trend_Minimum",
    MyK_Trend_Maximum: "MyK_Trend_Maximum",
    MyK_Trend_Enginespeed: "MyK_Trend_Enginespeed",
    MyK_HealthLabel_Maintenance_Recommendation: "MyK_HealthLabel_Maintenance_Recommendation",
    MyK_HealthLabel_SearchBy_Part_Recommendation: "MyK_HealthLabel_SearchBy_Part_Recommendation",
    MyK_Grid_ManufacturerName: "MyK_Grid_ManufacturerName",
    MyK_Grid_Maintenance_Recommendation: "MyK_Grid_Maintenance_Recommendation",
    MyK_Grid_SerialNumber: "MyK_Grid_SerialNumber",
    MyK_Grid_Quantity: "MyK_Grid_Quantity",
    MyK_HealthLabel_Optional_Part: "MyK_HealthLabel_Optional_Part",
    MyK_Label_ViewCart: "MyK_Label_ViewCart",
    MyK_Label_AddToCart: "MyK_Label_AddToCart",
    MyK_Label__ErrorMessage_Recommendation_Selection:
        "MyK_Label__ErrorMessage_Recommendation_Selection",
    MyK_Label_ErrorMessage_Recommendation_OneItem: "MyK_Label_ErrorMessage_Recommendation_OneItem",
    MyK_Label_Duration: "MyK_Label_Duration",
    MyK_UnitMeasurementUStons: "MyK_UnitMeasurementUStons",
    MyK_UnitMeasurementUSton: "MyK_UnitMeasurementUSton",
    MyK_UnitMeasurementTonnes: "MyK_UnitMeasurementTonnes",
    MyK_UnitMeasurementMiles: "MyK_UnitMeasurementMiles",
    MyK_UnitMeasurementProdMiles: "MyK_UnitMeasurementProdMiles",
    MyK_UnitMeasurementKm: "MyK_UnitMeasurementKm",
    MyK_UnitMeasurementMph: "MyK_UnitMeasurementMph",
    MyK_UnitMeasurementKmh: "MyK_UnitMeasurementKmh",
    MyK_UnitMeasurementUstonMph: "MyK_UnitMeasurementUstonMph",
    MyK_UnitMeasurementtonnesKmh: "MyK_UnitMeasurementtonnesKmh",
    MyK_UnitMeasurementDay: "MyK_UnitMeasurementDay",
    MyK_UnitMeasurementDays: "MyK_UnitMeasurementDays",
    MyK_UnitMeasurementSwing: "MyK_UnitMeasurementSwing",
    MyK_UnitMeasurementSwings: "MyK_UnitMeasurementSwings",
    MyK_UnitMeasurementCycle: "MyK_UnitMeasurementCycle",
    MyK_UnitMeasurementMilesPerCycle: "MyK_UnitMeasurementMilesPerCycle",
    MyK_Productivity_SwingloadCycle: "MyK_Productivity_SwingloadCycle",
    MyK_Productivity_SwingloadCount: "MyK_Productivity_SwingloadCount",
    MyK_ProdLabel_Swingload: "MyK_ProdLabel_Swingload",
    MyK_ProdLabel_AverageCycle: "MyK_ProdLabel_AverageCycle",
    MyK_Productivity_AvgCycleTime: "MyK_Productivity_AvgCycleTime",
    MyK_Productivity_AvgTime: "MyK_Productivity_AvgTime",
    Myk_Productivity_SwingTotal: "Myk_Productivity_SwingTotal",
    Myk_Productivity_HaulTotal: "Myk_Productivity_HaulTotal",
    MyK_Label_NoDataAvailable: "MyK_Label_NoDataAvailable",

    MyK_DateRange_Cancel: "MyK_DateRange_Cancel",
    MyK_DateRange_Apply: "MyK_DateRange_Apply",
    MyK_DateRange_From: "MyK_DateRange_From",
    MyK_DateRange_To: "MyK_DateRange_To",
    MyK_DateRange_Custom: "MyK_DateRange_Custom",
    MyK_DateRange_Today: "MyK_DateRange_Today",
    MyK_DateRange_Yesterday: "MyK_DateRange_Yesterday",
    MyK_DateRange_Last7Days: "MyK_DateRange_Last7Days",
    MyK_DateRange_Last30Days: "MyK_DateRange_Last30Days",
    MyK_DateRange_ThisMonth: "MyK_DateRange_ThisMonth",
    MyK_DateRange_LastMonth: "MyK_DateRange_LastMonth",
    MyK_DateRange_Su: "MyK_DateRange_Su",
    MyK_DateRange_Mo: "MyK_DateRange_Mo",
    MyK_DateRange_Tu: "MyK_DateRange_Tu",
    MyK_DateRange_We: "MyK_DateRange_We",
    MyK_DateRange_Th: "MyK_DateRange_Th",
    MyK_DateRange_Fr: "MyK_DateRange_Fr",
    MyK_DateRange_Sa: "MyK_DateRange_Sa",
    MyK_DateRange_January: "MyK_DateRange_January",
    MyK_DateRange_February: "MyK_DateRange_February",
    MyK_DateRange_March: "MyK_DateRange_March",
    MyK_DateRange_April: "MyK_DateRange_April",
    MyK_DateRange_May: "MyK_DateRange_May",
    MyK_DateRange_June: "MyK_DateRange_June",
    MyK_DateRange_July: "MyK_DateRange_July",
    MyK_DateRange_August: "MyK_DateRange_August",
    MyK_DateRange_September: "MyK_DateRange_September",
    MyK_DateRange_October: "MyK_DateRange_October",
    MyK_DateRange_November: "MyK_DateRange_November",
    MyK_DateRange_December: "MyK_DateRange_December",
    MyK_DataTable_groupPanelEmpty: "MyK_DataTable_groupPanelEmpty",
    MyK_DataTable_pagerItemsPerPage: "MyK_DataTable_pagerItemsPerPage",
    MyK_DataTable_pagerFirstPage: "MyK_DataTable_pagerFirstPage",
    MyK_DataTable_pagerPreviousPage: "MyK_DataTable_pagerPreviousPage",
    MyK_DataTable_pagerNextPage: "MyK_DataTable_pagerNextPage",
    MyK_DataTable_pagerLastPage: "MyK_DataTable_pagerLastPage",
    MyK_DataTable_pagerPage: "MyK_DataTable_pagerPage",
    MyK_DataTable_pagerOf: "MyK_DataTable_pagerOf",
    MyK_DataTable_pagerTotalPages: "MyK_DataTable_pagerTotalPages",
    MyK_DataTable_pagerInfo: "MyK_DataTable_pagerInfo",
    MyK_DataTable_pagerItemPerPage: "MyK_DataTable_pagerItemPerPage",
    MyK_DataTable_filterClearButton: "MyK_DataTable_filterClearButton",
    MyK_DataTable_filterEqOperator: "MyK_DataTable_filterEqOperator",
    MyK_DataTable_filterNotEqOperator: "MyK_DataTable_filterNotEqOperator",
    MyK_DataTable_filterIsNullOperator: "MyK_DataTable_filterIsNullOperator",
    MyK_DataTable_filterIsNotNullOperator: "MyK_DataTable_filterIsNotNullOperator",
    MyK_DataTable_filterIsEmptyOperator: "MyK_DataTable_filterIsEmptyOperator",
    MyK_DataTable_filterIsNotEmptyOperator: "MyK_DataTable_filterIsNotEmptyOperator",
    MyK_DataTable_filterStartsWithOperator: "MyK_DataTable_filterStartsWithOperator",
    MyK_DataTable_filterContainsOperator: "MyK_DataTable_filterContainsOperator",
    MyK_DataTable_filterNotContainsOperator: "MyK_DataTable_filterNotContainsOperator",
    MyK_DataTable_filterEndsWithOperator: "MyK_DataTable_filterEndsWithOperator",
    MyK_DataTable_filterGteOperator: "MyK_DataTable_filterGteOperator",
    MyK_DataTable_filterGtOperator: "MyK_DataTable_filterGtOperator",
    MyK_DataTable_filterLteOperator: "MyK_DataTable_filterLteOperator",
    MyK_DataTable_filterLtOperator: "MyK_DataTable_filterLtOperator",
    MyK_DataTable_filterIsTrue: "MyK_DataTable_filterIsTrue",
    MyK_DataTable_filterIsFalse: "MyK_DataTable_filterIsFalse",
    MyK_DataTable_filterBooleanAll: "MyK_DataTable_filterBooleanAll",
    MyK_DataTable_filterAfterOrEqualOperator: "MyK_DataTable_filterAfterOrEqualOperator",
    MyK_DataTable_filterAfterOperator: "MyK_DataTable_filterAfterOperator",
    MyK_DataTable_filterBeforeOperator: "MyK_DataTable_filterBeforeOperator",
    MyK_DataTable_filterBeforeOrEqualOperator: "MyK_DataTable_filterBeforeOrEqualOperator",
    MyK_DataTable_filterSubmitButton: "MyK_DataTable_filterSubmitButton",
    MyK_DataTable_filterAndLogic: "MyK_DataTable_filterAndLogic",
    MyK_DataTable_filterOrLogic: "MyK_DataTable_filterOrLogic",
    MyK_DataTable_filterTitle: "MyK_DataTable_filterTitle",
    MyK_DataTable_filterChooseOperator: "MyK_DataTable_filterChooseOperator",
    MyK_DataTable_filterSelectedItems: "MyK_DataTable_filterSelectedItems",
    MyK_DataTable_filterAriaLabel: "MyK_DataTable_filterAriaLabel",
    MyK_DataTable_sortAscending: "MyK_DataTable_sortAscending",
    MyK_DataTable_sortDescending: "MyK_DataTable_sortDescending",
    MyK_DataTable_sortAriaLabel: "MyK_DataTable_sortAriaLabel",
    MyK_DataTable_searchPlaceholder: "MyK_DataTable_searchPlaceholder",
    MyK_DataTable_noRecords: "MyK_DataTable_noRecords",
    MyK_DataTable_filterCheckAll: "MyK_DataTable_filterCheckAll",
    MyK_DataTable_groupColumn: "MyK_DataTable_groupColumn",
    MyK_DataTable_groupExpand: "MyK_DataTable_groupExpand",
    MyK_DataTable_groupCollapse: "MyK_DataTable_groupCollapse",
    MyK_DataTable_groupPanelAriaLabel: "MyK_DataTable_groupPanelAriaLabel",
    MyK_DataTable_ungroupColumn: "MyK_DataTable_ungroupColumn",
    MyK_DataTable_detailExpand: "MyK_DataTable_detailExpand",
    MyK_DataTable_detailCollapse: "MyK_DataTable_detailCollapse",
    MyK_Productivity_LoadedStopTime: "MyK_Productivity_LoadedStopTime",
    MyK_Trend_Compare_To_Fleet_Max: "MyK_Trend_Compare_To_Fleet_Max",
    MyK_Trend_Compare_To_Fleet_Min: "MyK_Trend_Compare_To_Fleet_Min",
    MyK_Trend_Compare_To_Fleet_Avg: "MyK_Trend_Compare_To_Fleet_Avg",
    MyK_Trend_Compare_To_FleetBtn_Max: "Compare to Fleet Max",
    MyK_Trend_Compare_To_FleetBtn_Min: "Compare to Fleet Min",
    MyK_Trend_Compare_To_FleetBtn_Avg: "Compare to Fleet Avg",
    MyK_Trend_Compare_To_Fleet_NumValidation: "Please enter the valid numeric value",
    MyK_Trend_Compare_To_Fleet_MaxMinCompareValidation:
        "Upper threshold value should be greater than lower threshold value",
    MyK_Trend_Compare_Max: "Max",
    MyK_Trend_Compare_Min: "Min",
    MyK_Trend_Compare_Avg: "Avg",
    MyK_Label_Threshold_DB: "MyK_Label_Threshold_DB",
    MyK_Label_Threshold_Cus: "MyK_Label_Threshold_Cus",
    MyK_Label_Threshold_Komatsu: "MyK_Label_Threshold_Komatsu",
    MyK_Label_Save: "MyK_Label_Save",
    MyK_Label_Cancel: "MyK_Label_Cancel",
    MyK_Label_Proceed: "MyK_Label_Proceed",
    MyK_Label_Apply_Filter: "MyK_Label_Apply_Filter",
    MyK_Trend_Save_SuccessMessage: "MyK_Trend_Save_SuccessMessage",
    MyK_Label_MyTrends: "MyK_Label_MyTrends",
    MyK_OrderKowa_Component: "MyK_OrderKowa_Component",
    MyK_OrderKowa_Price: "MyK_OrderKowa_Price",
    MyK_OrderKowaKit_Header: "MyK_OrderKowaKit_Header",
    MyK_Kowa_Top5_Report_Header: "MyK_Kowa_Top5_Report_Header",
    MyK_FCGrid_FCNumber: "MyK_FCGrid_FCNumber",
    MyK_FCGrid_PSNNumber: "MyK_FCGrid_PSNNumber",
    MyK_FCGrid_Type: "MyK_FCGrid_Type",
    MyK_FCGrid_EndDate: "MyK_FCGrid_EndDate",
    MyK_FCGrid_Status: "MyK_FCGrid_Status",
    MyK_FCGrid_ClaimStatus: "MyK_FCGrid_ClaimStatus",
    MyK_FCGrid_Subject: "MyK_FCGrid_Subject",
    MyK_FCGrid_Purpose: "MyK_FCGrid_Purpose",
    MyK_FCGrid_Safety: "MyK_FCGrid_Safety",
    MyK_FCGrid_Emission: "MyK_FCGrid_Emission",
    MyK_FCGrid_EstimatedLabor: "MyK_FCGrid_EstimatedLabor",
    MyK_FCGrid_MaximumSMRHours: "MyK_FCGrid_MaximumSMRHours",
    MyK_FactoryCampaign_Header: "MyK_FactoryCampaign_Header",
    MyK_FC_DistributorView: "MyK_FC_DistributorView",
    MyK_FC_CustomerView: "MyK_FC_CustomerView",
    MyK_FCLetter_Header: "MyK_FCLetter_Header",
    MyK_FC_CustomerInfoMsg: "MyK_FC_CustomerInfoMsg",
    MyK_QuickLink_Report: "MyK_QuickLink_Report",
    MyK_QuickLink_PartsBook: "MyK_QuickLink_PartsBook",
    MyK_QuickLink_QuickRefGuide: "MyK_QuickLink_QuickRefGuide",
    MyK_QuickLink_RecommendedPartList: "MyK_QuickLink_RecommendedPartList",
    MyK_QuickLink_NotesAttachments: "MyK_QuickLink_NotesAttachments",
    MyK_QuickLink_PartListRPL: "MyK_QuickLink_PartListRPL",
    MyK_QuickLink_Notes: "MyK_QuickLink_Notes",
    MyK_QuickLink_KowaReport: "MyK_QuickLink_KowaReport",
    MyK_QuickLink_CareReport: "MyK_QuickLink_CareReport",
    MyK_QuickLink_CreateAlert: "MyK_QuickLink_CreateAlert",
    MyK_Promotion_BreadcrumbHeader: "MyK_Promotion_BreadcrumbHeader",
    MyK_Promotion_Header: "MyK_Promotion_Header",
    MyK_Promotion_ApplicableModels: "MyK_Promotion_ApplicableModels",
    MyK_Promotion_StartingFrom: "MyK_Promotion_StartingFrom",
    MyK_Promotion_To: "MyK_Promotion_To",
    MyK_Label_LastReported: "MyK_Label_LastReported",
    MyK_Label_ServicedBy: "MyK_Label_ServicedBy",
    MyK_Label_SoldBy: "MyK_Label_SoldBy",
    Myk_Label_ViewDetails: "Myk_Label_ViewDetails",
    MyK_Label_Manuals: "MyK_Label_Manuals",
    MyK_Label_Share: "MyK_Label_Share",
    MyK_Label_SMRH: "MyK_Label_SMRH",
    MyK_Label_SMRDATE: "MyK_Label_SMRDATE",
    MyK_Label_IDLETIME: "MyK_Label_IDLETIME",
    MyK_Label_modelimage: "MyK_Label_modelimage",
    MyK_Label_vehicle: "MyK_Label_vehicle",
    MyK_Label_SoldByDistributor: "MyK_Label_SoldByDistributor",
    MyK_Label_TerritaryDistributor: "MyK_Label_TerritaryDistributor",
    MyK_Label_Customer: "MyK_Label_Customer",
    MyK_Label_CurrentHoursSMRH: "MyK_Label_CurrentHoursSMRH",
    MyK_Label_FuelBrunt: "MyK_Label_FuelBrunt",
    MyK_Label_ManualBook: "MyK_Label_ManualBook",
    MyK_Label_LocateMap: "MyK_Label_LocateMap",
    MyK_Label_globe: "MyK_Label_globe",
    MyK_Label_setting: "MyK_Label_setting",
    MyK_Label_book: "MyK_Label_book",
    Myk_Label_fleetManagemntLocation: "Myk_Label_fleetManagemntLocation",
    Myk_Label_QuickLinkSearch: "Myk_Label_QuickLinkSearch",
    Myk_Label_fleetBook: "Myk_Label_fleetBook",
    Myk_Label_fleetexternal: "Myk_Label_fleetexternal",
    MyK_Label_Parts: "MyK_Label_Parts",
    MyK_Label_PreviousReport: "MyK_Label_PreviousReport",
    MyK_Label_KowaReport: "MyK_Label_KowaReport",
    MyK_Label_PartsRecommended: "MyK_Label_PartsRecommended",
    MyK_Label_SerialNo: "MyK_Label_SerialNo",
    MyK_Label_UnitNo: "MyK_Label_UnitNo",
    MyK_Label_Sold: "MyK_Label_Sold",
    MyK_Label_CurrentHours: "MyK_Label_CurrentHours",
    MyK_Label_IdlingTime: "MyK_Label_IdlingTime",
    MyK_Label_FuelBurned: "MyK_Label_FuelBurned",
    MyK_Label_Distributor: "MyK_Label_Distributor",
    MyK_Label_Service: "MyK_Label_Service",
    MyK_FleetLabel_HybridView: "MyK_FleetLabel_HybridView",
    MyK_FleetLabel_MapView: "MyK_FleetLabel_MapView",
    MyK_FleetLabel_TableView: "MyK_FleetLabel_TableView",
    MyK_FleetLabel_CardView: "MyK_FleetLabel_CardView",
    MyK_FleetLabel_MyFleetManagement: "MyK_FleetLabel_MyFleetManagement",
    MyK_FleetLabel_ManageOtherOEM: "MyK_FleetLabel_ManageOtherOEM",
    MyK_FleetLabel_ShowingResult: "MyK_FleetLabel_ShowingResult",
    MyK_FleetLabel_ShowingResultText: "MyK_FleetLabel_ShowingResultText",
    MyK_FleetLabel_QuickStatsDay: "MyK_FleetLabel_QuickStatsDay",
    MyK_FleetLabel_QuickStatsWeek: "MyK_FleetLabel_QuickStatsWeek",
    MyK_FleetLabel_QuickStatsMonth: "MyK_FleetLabel_QuickStatsMonth",
    MyK_FleetLabel_QuickStatCustom: "MyK_FleetLabel_QuickStatCustom",
    MyK_FleetLabel_QuickStat_FleetHours: "MyK_FleetLabel_QuickStat_FleetHours",
    MyK_FleetLabel_QuickStat_FleetHours_Tooltip: "MyK_FleetLabel_QuickStat_FleetHours_Tooltip",
    MyK_FleetLabel_QuickStat_Cautions: "MyK_FleetLabel_QuickStat_Cautions",
    MyK_FleetLabel_QuickStat_Cautions_Tooltip: "MyK_FleetLabel_QuickStat_Cautions_Tooltip",
    MyK_FleetLabel_QuickStat_Abnormalities: "MyK_FleetLabel_QuickStat_Abnormalities",
    MyK_FleetLabel_QuickStat_Abnormalities_Tooltip: "MyK_FleetLabel_QuickStat_Abnormalities_Tooltip",
    MyK_FleetLabel_QuickStat_Movements: "MyK_FleetLabel_QuickStat_Movements",
    MyK_FleetLabel_QuickStat_Movements_Tooltip: "MyK_FleetLabel_QuickStat_Movements_Tooltip",
    MyK_FleetLabel_QuickStat_NoCommunication: "MyK_FleetLabel_QuickStat_NoCommunication",
    MyK_FleetLabel_QuickStat_NoCommunication_Tooltip:
        "MyK_FleetLabel_QuickStat_NoCommunication_Tooltip",
    MyK_FleetLabel_QuickStat_NoUsage: "MyK_FleetLabel_QuickStat_NoUsage",
    MyK_FleetLabel_QuickStat_NoUsage_Tooltip: "MyK_FleetLabel_QuickStat_NoUsage_Tooltip",
    MyK_FleetLabel_QuickStat_FactoryCampaign: "MyK_FleetLabel_QuickStat_FactoryCampaign",
    MyK_FleetLabel_QuickStat_FactoryCampaign_Tooltip:
        "MyK_FleetLabel_QuickStat_FactoryCampaign_Tooltip",
    MyK_FleetLabel_QuickStat_Maintenance: "MyK_FleetLabel_QuickStat_Maintenance",
    MyK_FleetLabel_QuickStat_Maintenance_Tooltip: "MyK_FleetLabel_QuickStat_Maintenance_Tooltip",
    MyK_FleetLabel_Search: "MyK_FleetLabel_Search",
    MyK_FleetLabel_FilterSort: "MyK_FleetLabel_FilterSort",
    MyK_FleetLabel_MachinesManaged: "MyK_FleetLabel_MachinesManaged",
    MyK_FleetLabel_SyncToList: "MyK_FleetLabel_SyncToList",
    MyK_FleetLabel_ClearSyncToList: "MyK_FleetLabel_ClearSyncToList",
    MyK_FleetLabel_MachinesMapped: "MyK_FleetLabel_MachinesMapped",
    MyK_FleetLabel_Ascending: "MyK_FleetLabel_Ascending",
    MyK_FleetLabel_Descending: "MyK_FleetLabel_Descending",
    MyK_FleetLabel_FleetPerformance: "MyK_FleetLabel_FleetPerformance",
    MyK_FleetLabel_HeavyVsLight: "MyK_FleetLabel_HeavyVsLight",
    MyK_FleetLabel_EmodeVPMode: "MyK_FleetLabel_EmodeVPMode",
    MyK_FleetLabel_AvgIdleHours: "MyK_FleetLabel_AvgIdleHours",
    MyK_FleetLabel_AvgFuelConsumption: "MyK_FleetLabel_AvgFuelConsumption",
    MyK_FleetLabel_AvgEngineHours: "MyK_FleetLabel_AvgEngineHours",
    MyK_MyCoverage_Status: "MyK_MyCoverage_Status",
    MyK_MyCoverage_Type: "MyK_MyCoverage_Type",
    MyK_MyCoverage_Terms: "MyK_MyCoverage_Terms",
    MyK_MyCoverage_StartDate: "MyK_MyCoverage_StartDate",
    MyK_MyCoverage_ExpiryDate: "MyK_MyCoverage_ExpiryDate",
    MyK_MyCoverage_ExpiryRemainingHours: "MyK_MyCoverage_ExpiryRemainingHours",
    MyK_MyCoverage_CoverageHistory: "MyK_MyCoverage_CoverageHistory",
    MyK_MyCoverage_KomatsuCareHistory: "MyK_MyCoverage_KomatsuCareHistory",
    MyK_MyCoverage_Claim: "MyK_MyCoverage_Claim",
    MyK_MyCoverage_FailComponent: "MyK_MyCoverage_FailComponent",
    MyK_MyCoverage_Phenomenon: "MyK_MyCoverage_Phenomenon",
    MyK_MyCoverage_CriticalFailPartNumber: "MyK_MyCoverage_CriticalFailPartNumber",
    MyK_MyCoverage_FailDate: "MyK_MyCoverage_FailDate",
    MyK_MyCoverage_FailSMR: "MyK_MyCoverage_FailSMR",
    MyK_MyCoverage_RepairDate: "MyK_MyCoverage_RepairDate",
    MyK_MyCoverage_CoverageClaim: "MyK_MyCoverage_CoverageClaim",
    MyK_MyCoverage_NonCoverageClaim: "MyK_MyCoverage_NonCoverageClaim",
    MyK_MyCoverage_CareClaim: "MyK_MyCoverage_CareClaim",
    MyK_Label_Close: "MyK_Label_Close",
    MyK_Label_CareReport: "MyK_Label_CareReport",
    MyK_Label_Advantage: "MyK_Label_Advantage",
    MyK_Label_KomatsuCarePlus: "MyK_Label_KomatsuCarePlus",
    MyK_Label_KomatsuCarePlusII: "MyK_Label_KomatsuCarePlusII",
    MyK_Label_RequestQuote: "MyK_Label_RequestQuote",
    MyK_FleetLabel_TileView: "MyK_FleetLabel_TileView",
    MyK_FleetLabel_FleetPerformanceClose: "MyK_FleetLabel_FleetPerformanceClose",
    MyK_FleetLabel_FleetPerformanceShow: "MyK_FleetLabel_FleetPerformanceShow",
    MyK_FleetLabel_LastOneDay: "MyK_FleetLabel_LastOneDay",
    MyK_FleetLabel_LastOneweek: "MyK_FleetLabel_LastOneweek",
    MyK_FleetLabel_LastOneMonth: "MyK_FleetLabel_LastOneMonth",
    MyK_FleetLabel_Customreport: "MyK_FleetLabel_Customreport",
    MyK_Manage_Quicklinks: "MyK_Manage_Quicklinks",
    MyK_Title_FC_CustomerView: "MyK_Title_FC_CustomerView",
    MyK_Title_FC_DistributorView: "MyK_Title_FC_DistributorView",
    MyK_Promotion_ViewAll: "MyK_Promotion_ViewAll",
    MyK_FleetLabel_FCOpensOn: "MyK_FleetLabel_FCOpensOn",
    MyK_Mytier_ClickViewDetails: "MyK_Mytier_ClickViewDetails",
    MyK_Mytier_WhatIsThis: "MyK_Mytier_WhatIsThis",
    MyK_MyFleet_AllProducts: "MyK_MyFleet_AllProducts",
    MyK_Label_NoLocationAvailable: "MyK_Label_NoLocationAvailable",
    MyK_MyFleet_IdleTime: "MyK_MyFleet_IdleTime",
    MyK_Label_Kowa: "MyK_Label_Kowa",
    MyK_Label_ExportMsg: "MyK_Label_ExportMsg",
    MyK_Label_ExportConfirm: "MyK_Label_ExportConfirm",
    MyK_Label_KomatsuCareLiterature: "MyK_Label_KomatsuCareLiterature",
    MyK_Label_Length: "MyK_Label_Length",
    MyK_Label_MachineAge: "MyK_Label_MachineAge",
    MyK_Label_Programs: "MyK_Label_Programs",
    MyK_Label_ExtendedCoverage: "MyK_Label_ExtendedCoverage",
    MyK_Label_KomatsuCarePrograms: "MyK_Label_KomatsuCarePrograms",
    MyK_Label_CoverageType: "MyK_Label_CoverageType",
    MyK_Label_Comments: "MyK_Label_Comments",
    MyK_Label_SubmitRequest: "MyK_Label_SubmitRequest",
    MyK_Label_MaintenanceClaimHistory: "MyK_Label_MaintenanceClaimHistory",
    MyK_Label_Months: "MyK_Label_Months",
    MyK_Label_Expired: "MyK_Label_Expired",
    MyK_Label_Days: "MyK_Label_Days",
    MyK_Label_Coverages: "MyK_Label_Coverages",
    MyK_Label_RemainingSMRHours: "MyK_Label_RemainingSMRHours",
    MyK_Label_Hrs: "MyK_Label_Hrs",
    MyK_Label_RemainingDays: "MyK_Label_RemainingDays",
    MyK_Label_LastReportedSMR: "MyK_Label_LastReportedSMR",
    MyK_Label_CurrentDate: "MyK_Label_CurrentDate",
    MyK_Label_CurrentDay: "MyK_Label_CurrentDay",
    MyK_Label_FuelBruntL: "MyK_Label_FuelBruntL",
    MyK_Label_FuelBurnedL: "MyK_Label_FuelBurnedL",
    MyK_Label_MyKomatsuOperationReport: "MyK_Label_MyKomatsuOperationReport",
    MyK_Label_KomatsuCareReport: "MyK_Label_KomatsuCareReport",
    MyK_Label_ManageSchedule: "MyK_Label_ManageSchedule",
    MyK_Label_Claims: "MyK_Label_Claims",
    MyK_IMCLabel_MCWorkingHours: "MyK_IMCLabel_MCWorkingHours",
    MyK_IMCLabel_MCMGUsageHours: "MyK_IMCLabel_MCMGUsageHours",
    MyK_IMCLabel_MCAutoOnHeavyLoad: "MyK_IMCLabel_MCAutoOnHeavyLoad",
    MyK_IMCLabel_MCAutoOnNormalLoad: "MyK_IMCLabel_MCAutoOnNormalLoad",
    MyK_IMCLabel_MCAutoOnLightLoad: "MyK_IMCLabel_MCAutoOnLightLoad",
    MyK_IMCLabel_AmountFuelConsumption: "MyK_IMCLabel_AmountFuelConsumption",
    MyK_IMCLabel_AmountFuelConsumptionL: "MyK_IMCLabel_AmountFuelConsumptionL",
    MyK_IMCLabel_ManualIntervention: "MyK_IMCLabel_ManualIntervention",
    MyK_IMCLabel_ShoeSlippingTime: "MyK_IMCLabel_ShoeSlippingTime",
    MyK_IMCLabel_Load1: "MyK_IMCLabel_Load1",
    MyK_IMCLabel_Load2: "MyK_IMCLabel_Load2",
    MyK_IMCLabel_Load3: "MyK_IMCLabel_Load3",
    MyK_IMCLabel_Load4: "MyK_IMCLabel_Load4",
    MyK_IMCLabel_MCAutoOffForwardWorking: "MyK_IMCLabel_MCAutoOffForwardWorking",
    MyK_IMCLabel_MCAutoOnForwardWorking: "MyK_IMCLabel_MCAutoOnForwardWorking",
    MyK_IMCLabel_DozingModeLowSpeed: "MyK_IMCLabel_DozingModeLowSpeed",
    MyK_IMCLabel_DozingModeMidSpeed: "MyK_IMCLabel_DozingModeMidSpeed",
    MyK_IMCLabel_DozingModeHighSpeed: "MyK_IMCLabel_DozingModeHighSpeed",
    MyK_IMCLabel_ForwardWorking: "MyK_IMCLabel_ForwardWorking",
    MyK_IMCLabel_MCApproachingDesign: "MyK_IMCLabel_MCApproachingDesign",
    MyK_IMCLabel_HiElevationUnder: "MyK_IMCLabel_HiElevationUnder",
    MyK_IMCLabel_MCAutoOnCuttingMode: "MyK_IMCLabel_MCAutoOnCuttingMode",
    MyK_IMCLabel_MCAutoOnSpreadingMode: "MyK_IMCLabel_MCAutoOnSpreadingMode",
    MyK_IMCLabel_MCAutoOnSimpleMode: "MyK_IMCLabel_MCAutoOnSimpleMode",
    MyK_IMCLabel_MCBackGrage: "MyK_IMCLabel_MCBackGrage",
    MyK_IMCLabel_MiddleElevationUnder: "MyK_IMCLabel_MiddleElevationUnder",
    MyK_IMCLabel_SummaryDate: "MyK_IMCLabel_SummaryDate",
    MyK_IMCLabel_TrackSlip: "MyK_IMCLabel_TrackSlip",
    MyK_IMCLabel_ManualOverride: "MyK_IMCLabel_ManualOverride",
    MyK_IMCLabel_TimeMonitor: "MyK_IMCLabel_TimeMonitor",
    MyK_IMCLabel_Forward: "MyK_IMCLabel_Forward",
    MyK_IMCLabel_CutCarry: "MyK_IMCLabel_CutCarry",
    MyK_IMCLabel_SimpleGrade: "MyK_IMCLabel_SimpleGrade",
    MyK_IMCLabel_Gallon: "MyK_IMCLabel_Gallon",
    Myk_Label_Contacts: "Myk_Label_Contacts",
    Myk_Label_Branch: "Myk_Label_Branch",
    Myk_Label_Address: "Myk_Label_Address",
    Myk_Label_Phone: "Myk_Label_Phone",
    Myk_Label_Divisions: "Myk_Label_Divisions",
    Myk_Label_Hours: "Myk_Label_Hours",
    Myk_Label_Open: "Myk_Label_Open",
    Myk_Label_Closed: "Myk_Label_Closed",
    Myk_Label_OpenText: "Myk_Label_OpenText",
    MyK_Notify_Distributor: "MyK_Notify_Distributor",
    MyK_Notify_Customer: "MyK_Notify_Customer",
    MyK_Notify_DistributorCustomer: "MyK_Notify_DistributorCustomer",
    MyK_Distributor_Contacts: "MyK_Distributor_Contacts",
    MyK_Authorized_Distributor: "MyK_Authorized_Distributor",
    Myk_Label_Fax: "Myk_Label_Fax",
    Myk_Label_ClosesAt: "Myk_Label_ClosesAt",
    Myk_Label_Segment: "Myk_Label_Segment",
    Myk_Label_At: "Myk_Label_At",
    Myk_Label_OpensBy: "Myk_Label_OpensBy",
    MyK_IMCLabel_Liter: "MyK_IMCLabel_Liter",
    MyK_CoverageLabel_RequestQuote_DurationInfo: "MyK_CoverageLabel_RequestQuote_DurationInfo",
    MyK_Label_ErrorMessage_RequestQuote: "MyK_Label_ErrorMessage_RequestQuote",
    MyK_Label_SuccessMessage_RequestQuote: "MyK_Label_SuccessMessage_RequestQuote",
    MyK_Label_ErrorMessage_RequestQuote_DurationInfo:
        "MyK_Label_ErrorMessage_RequestQuote_DurationInfo",
    MyK_Label_KowaReport_Sample_Date: "MyK_Label_KowaReport_Sample_Date",
    MyK_Label_KowaReport_Component_Description: "MyK_Label_KowaReport_Component_Description",
    MyK_Label_KowaReport_View: "MyK_Label_KowaReport_View",
    MyK_Label_KowaReport_Status: "MyK_Label_KowaReport_Status",
    MyK_Label_KowaReport_Sample_Analysis_Report: "MyK_Label_KowaReport_Sample_Analysis_Report",
    MyK_Label_KowaReport_Account_Information: "MyK_Label_KowaReport_Account_Information",
    MyK_Label_KowaReport_Sample_Information: "MyK_Label_KowaReport_Sample_Information",
    MyK_Label_KowaReport_Lab_Customer_ID: "MyK_Label_KowaReport_Lab_Customer_ID",
    MyK_Label_KowaReport_Company_Name: "MyK_Label_KowaReport_Company_Name",
    MyK_Label_KowaReport_Company_Worksite: "MyK_Label_KowaReport_Company_Worksite",
    MyK_Label_KowaReport_Company_Address: "MyK_Label_KowaReport_Company_Address",
    MyK_Label_KowaReport_Sample_Tracking: "MyK_Label_KowaReport_Sample_Tracking",
    MyK_Label_KowaReport_Completed_Date: "MyK_Label_KowaReport_Completed_Date",
    MyK_Label_KowaReport_Unit_Information: "MyK_Label_KowaReport_Unit_Information",
    MyK_Label_KowaReport_Component_Information: "MyK_Label_KowaReport_Component_Information",
    MyK_Label_KowaReport_Unit_Id: "MyK_Label_KowaReport_Unit_Id",
    MyK_Label_KowaReport_Unit_Mfg: "MyK_Label_KowaReport_Unit_Mfg",
    MyK_Label_KowaReport_Unit_Model: "MyK_Label_KowaReport_Unit_Model",
    MyK_Label_KowaReport_Unit_Serial: "MyK_Label_KowaReport_Unit_Serial",
    MyK_Label_KowaReport_Cpnt_Description: "MyK_Label_KowaReport_Cpnt_Description",
    MyK_Label_KowaReport_Cpnt_Mfg: "MyK_Label_KowaReport_Cpnt_Mfg",
    MyK_Label_KowaReport_Cpnt_Model: "MyK_Label_KowaReport_Cpnt_Model",
    MyK_Label_KowaReport_Cpnt_Serial: "MyK_Label_KowaReport_Cpnt_Serial",
    MyK_Label_KowaReport_Cpnt_Type: "MyK_Label_KowaReport_Cpnt_Type",
    MyK_Label_KowaReport_Recommendations: "MyK_Label_KowaReport_Recommendations",
    MyK_Label_KowaReport_Results: "MyK_Label_KowaReport_Results",
    MyK_Label_SelectOption: "MyK_Label_SelectOption",
    MyK_Label_AmountSlipText: "MyK_Label_AmountSlipText",
    MyK_IMCLabel_Month: "MyK_IMCLabel_Month",
    MyK_Label_MachineTimeZone: "MyK_Label_MachineTimeZone",
    MyK_ReportingLabel_ReportName: "MyK_ReportingLabel_ReportName",
    MyK_ReportingLabel_NoteMessage: "MyK_ReportingLabel_NoteMessage",
    MyK_ReportingLabel_MachineShown: "MyK_ReportingLabel_MachineShown",
    MyK_ReportingLabel_Dealers: "MyK_ReportingLabel_Dealers",
    MyK_ReportingLabel_Customers: "MyK_ReportingLabel_Customers",
    MyK_ReportingLabel_Locations: "MyK_ReportingLabel_Locations",
    MyK_IMCLabel_AutoAtFinishGrade: "MyK_IMCLabel_AutoAtFinishGrade",
    MyK_IMCLabel_AutoBladeText: "MyK_IMCLabel_AutoBladeText",
    MyK_IMCLabel_AutoForwardReverseText: "MyK_IMCLabel_AutoForwardReverseText",
    MyK_IMCLabel_AutoOn: "MyK_IMCLabel_AutoOn",
    MyK_IMCLabel_ManualOverrideText: "MyK_IMCLabel_ManualOverrideText",
    MyK_Label_KowaReport_Maintenance_Recommendation_Code:
        "MyK_Label_KowaReport_Maintenance_Recommendation_Code",
    MyK_Label_KowaReport_Spectrochemical_Analysis: "MyK_Label_KowaReport_Spectrochemical_Analysis",
    MyK_Label_KowaReport_Fluid_Properties: "MyK_Label_KowaReport_Fluid_Properties",
    MyK_Label_KowaReport_Message_Bureau_Veritas_Testing:
        "MyK_Label_KowaReport_Message_Bureau_Veritas_Testing",
    MyK_Label_KowaReport_Message_Kowa_Report_Notice:
        "MyK_Label_KowaReport_Message_Kowa_Report_Notice",
    MyK_Label_SavePartList: "MyK_Label_SavePartList",
    MyK_Label_ShoppingListName: "MyK_Label_ShoppingListName",
    MyK_Label_SharedPartListCustomer: "MyK_Label_SharedPartListCustomer",
    MyK_Label_PersonalPartsList: "MyK_Label_PersonalPartsList",
    MyK_HealthLabel_CPT: "MyK_HealthLabel_CPT",
    MyK_HealthLabel_CPT_Add: "MyK_HealthLabel_CPT_Add",
    MyK_HealthLabel_CPT_Acknowledgement: "MyK_HealthLabel_CPT_Acknowledgement",
    MyK_HealthLabel_CPT_AckButton: "MyK_HealthLabel_CPT_AckButton",
    MyK_HealthLabel_CPT_Outstanding: "MyK_HealthLabel_CPT_Outstanding",
    MyK_HealthLabel_CPT_Addcomponenttrack: "MyK_HealthLabel_CPT_Addcomponenttrack",
    MyK_HealthLabel_CPT_Acknowledgement_Term: "MyK_HealthLabel_CPT_Acknowledgement_Term",
    MyK_HealthLabel_CPT_ACC_serial: "MyK_HealthLabel_CPT_ACC_serial",
    MyK_HealthLabel_CPT_Component: "MyK_HealthLabel_CPT_Component",
    MyK_HealthLabel_CPT_ACC_SMR_Interval: "MyK_HealthLabel_CPT_ACC_SMR_Interval",
    MyK_HealthLabel_CPT_ACC_Custom_Service_Date: "MyK_HealthLabel_CPT_ACC_Custom_Service_Date",
    MyK_HealthLabel_CPT_ACC_Last_Service_Date: "MyK_HealthLabel_CPT_ACC_Last_Service_Date",
    MyK_HealthLabel_CPT_ACC_Last_SMR_Service_Date: "MyK_HealthLabel_CPT_ACC_Last_SMR_Service_Date",
    MyK_HealthLabel_CPT_ACC_SMR_Last_Date: "MyK_HealthLabel_CPT_ACC_SMR_Last_Date",
    MyK_HealthLabel_CPT_ACC_SMR_Last_Service: "MyK_HealthLabel_CPT_ACC_SMR_Last_Service",
    MyK_HealthLabel_CPT_ACC_Current_SMR: "MyK_HealthLabel_CPT_ACC_Current_SMR",
    MyK_HealthLabel_CPT_ACC_Hours_Next_Service: "MyK_HealthLabel_CPT_ACC_Hours_Next_Service",
    MyK_HealthLabel_CPT_ACC_LastModified_Date: "MyK_HealthLabel_CPT_ACC_LastModified_Date",
    MyK_HealthLabel_CPT_ACC_LastModified_Username: "MyK_HealthLabel_CPT_ACC_LastModified_Username",
    MyK_HealthLabel_CPT_ACC_Filter_Sort: "MyK_HealthLabel_CPT_ACC_Filter_Sort",
    MyK_HealthLabel_CPT_ACC_Upload: "MyK_HealthLabel_CPT_ACC_Upload",
    MyK_HealthLabel_CPT_ACC_Download_Template: "MyK_HealthLabel_CPT_ACC_Download_Template",
    MyK_HealthLabel_CPT_ACC_Export: "MyK_HealthLabel_CPT_ACC_Export",
    MyK_HealthLabel_CPT_ACC_Filter_IsGreaterThan: "MyK_HealthLabel_CPT_ACC_Filter_IsGreaterThan",
    MyK_HealthLabel_CPT_ACC_Filter_IsLesserThan: "MyK_HealthLabel_CPT_ACC_Filter_IsLesserThan",
    MyK_HealthLabel_CPT_ACC_Filter_And: "MyK_HealthLabel_CPT_ACC_Filter_And",
    MyK_HealthLabel_CPT_ACC_Filter_Or: "MyK_HealthLabel_CPT_ACC_Filter_Or",
    MyK_HealthLabel_CPT_ACC_Filter_FilterBy: "MyK_HealthLabel_CPT_ACC_Filter_FilterBy",
    MyK_HealthLabel_CPT_ACC_Filter_SortBy: "MyK_HealthLabel_CPT_ACC_Filter_SortBy",
    MyK_HealthLabel_CPT_ACC_Filter_Sort_Ascending: "MyK_HealthLabel_CPT_ACC_Filter_Sort_Ascending",
    MyK_HealthLabel_CPT_ACC_Filter_Sort_Descending: "MyK_HealthLabel_CPT_ACC_Filter_Sort_Descending",
    MyK_HealthLabel_CPT_Download_Template: "MyK_HealthLabel_CPT_Download_Template",
    MyK_HealthLabel_CPT_Upload: "MyK_HealthLabel_CPT_Upload",
    MyK_HealthLabel_CPT_Alert_Message: "MyK_HealthLabel_CPT_Alert_Message",
    MyK_HealthLabel_CPT_SMR_Interval_Info_Message: "MyK_HealthLabel_CPT_SMR_Interval_Info_Message",
    MyK_HealthLabel_CPT_SMR_Interval_Zero_Info_Message: "MyK_HealthLabel_CPT_SMR_Interval_Zero_Info_Message",
    MyK_Label_SavePartListSuccessStatus: "MyK_Label_SavePartListSuccessStatus",
    MyK_Label_SavePartListFailureStatus: "MyK_Label_SavePartListFailureStatus",
    MyK_Label_ClearAll: "MyK_Label_ClearAll",
    MyK_OrderHistory_PONumber: "MyK_OrderHistory_PONumber",
    MyK_Label_OrderStatus: "MyK_Label_OrderStatus",
    MyK_Label_ViewOrderHistory: "MyK_Label_ViewOrderHistory",
    MyK_OrderStatus_Notification: "MyK_OrderStatus_Notification",
    MyK_Label_NoOrderNotification: "MyK_Label_NoOrderNotification",
    MyK_OrderInfo_Pending: "MyK_OrderInfo_Pending",
    MyK_OrderInfo_OrderPlaced: "MyK_OrderInfo_OrderPlaced",
    MyK_OrderInfo_Completed: "MyK_OrderInfo_Completed",
    MyK_OrderInfo_Shipped: "MyK_OrderInfo_Shipped",
    MyK_OrderInfo_PartiallyShipped: "MyK_OrderInfo_PartiallyShipped",
    MyK_OrderInfo_Cancelled: "MyK_OrderInfo_Cancelled",
    MyK_HealthLabel_Deleted_Error_Message: "MyK_HealthLabel_Deleted_Error_Message",
    MyK_HealthLabel_Deleted_Success_Message: "MyK_HealthLabel_Deleted_Success_Message",
    MyK_HealthLabel_CPT_Component_Deleted_Message: "MyK_HealthLabel_CPT_Component_Deleted_Message",
    MyK_HealthLabel_CPT_Segment_Deleted_Message: "MyK_HealthLabel_CPT_Segment_Deleted_Message",
    MyK_HealthLabel_CPT_File_Incorrect_Extension: "MyK_HealthLabel_CPT_File_Incorrect_Extension",
    MyK_Label_SelectAtleastOneMachine: "MyK_Label_SelectAtleastOneMachine",
    MyK_Label_Not_Applicable: "MyK_Label_Not_Applicable",
    MyK_Filter_Clear_success: "MyK_Filter_Clear_success",
    MyK_Myhealth_Segment_Name: "MyK_Myhealth_Segment_Name",
    MyK_GeneralAttribute_CompanyPhone: "MyK_GeneralAttribute_CompanyPhone",
    MyK_GeneralAttribute_EditPhoneNumber: "MyK_GeneralAttribute_EditPhoneNumber",
    MyK_GeneralAttribute_SavePhoneNumber: "MyK_GeneralAttribute_SavePhoneNumber",
    MyK_GeneralAttribute_CancelPhoneNumber: "MyK_GeneralAttribute_CancelPhoneNumber",
    MyK_Label_CompanyName: "MyK_Label_CompanyName",
    MyK_Utilization_DailyNotification: "MyK_Utilization_DailyNotification",
    MyK_Utilization_MonthlyNotification: "MyK_Utilization_MonthlyNotification",
    MyK_Label_EditUnit: "MyK_Label_EditUnit",
    MyK_Label_CancelUnit: "MyK_Label_CancelUnit",
    MyK_Label_SaveUnit: "MyK_Label_SaveUnit",
    MyK_Myhealth_Completed_Hours_InPercentage: "MyK_Myhealth_Completed_Hours_InPercentage",
    MyK_Label_Delete_Confirm_Title: "MyK_Label_Delete_Confirm_Title",
    MyK_Label_Confirm_Title: "MyK_Label_Confirm_Title",
    MyK_HealthLabel_CPT_SMR_Interval_Zero_Confirm_Message: "MyK_HealthLabel_CPT_SMR_Interval_Zero_Confirm_Message",
    MyK_Label_Delete_Confirm_Message: "MyK_Label_Delete_Confirm_Message",
    MyK_HealthLabel_CPT_Add_Component_Validation: "MyK_HealthLabel_CPT_Add_Component_Validation",
    MyK_Utilization_HoverNote: "MyK_Utilization_HoverNote",
    MyK_Label_Edit: "MyK_Label_Edit",
    MyK_Label_Delete: "MyK_Label_Delete",
    MyK_Label_No: "MyK_Label_No",
    MyK_Label_Yes: "MyK_Label_Yes",
    MyK_Label_OK: "MyK_Label_OK",
    MyK_Health_CPT_SMR_Error_Message: "MyK_Health_CPT_SMR_Error_Message",
    MyK_Health_CPT_SMR_Interval_Error_Message: "MyK_Health_CPT_SMR_Interval_Error_Message",
    MyK_Label_SendTo: "MyK_Label_SendTo",
    MyK_ReportLabel_ReportUOM: "MyK_ReportLabel_ReportUOM",
    MyK_ReportLabel_ReportLanguage: "MyK_ReportLabel_ReportLanguage",
    MyK_ReportLabel_ReportSearchPlaceholder: "MyK_ReportLabel_ReportSearchPlaceholder",
    MyK_Label_MachineHealthScore: "MyK_Label_MachineHealthScore",
    MyK_Label_TableView: "MyK_Label_TableView",
    MyK_Label_ChartView: "MyK_Label_ChartView",
    MyK_Label_SwitchTableView: "MyK_Label_SwitchTableView",
    MyK_Label_ChartTableView: "MyK_Label_ChartTableView",
    MyK_Label_KeyLifecycleEvents: "MyK_Label_KeyLifecycleEvents",
    MyK_Label_Noitemtodisplay: "MyK_Label_Noitemtodisplay",
    MyK_Label_DailyView: "MyK_Label_DailyView",
    MyK_Label_MonthlyView: "MyK_Label_MonthlyView",
    MyK_Label_AddToList: "MyK_Label_AddToList",
    MyK_Label_SelectModels: "MyK_Label_SelectModels",
    MyK_Label_SelectSerial: "MyK_Label_SelectSerial",
    MyK_Label_SelectUnit: "MyK_Label_SelectUnit",
    MyK_Label_ShowDistributorBranch: "MyK_Label_ShowDistributorBranch",
    MyK_General_PhoneValidationMsg: "MyK_General_PhoneValidationMsg",
    MyK_Label_Search: "MyK_Label_Search",
    MyK_UtilGrid_FuelUsed: "MyK_UtilGrid_FuelUsed",
    MyK_UtilGrid_Distance: "MyK_UtilGrid_Distance",
    MyK_Grid_Validation_Msg_Required: "MyK_Grid_Validation_Msg_Required",
    MyK_Grid_Validation_Msg_SMR: "MyK_Grid_Validation_Msg_SMR",
    MyK_Grid_Validation_Msg_SMRDate: "MyK_Grid_Validation_Msg_SMRDate",
    MyK_Grid_Mark_As_Complete: "MyK_Grid_Mark_As_Complete",
    MyK_FleetChartLabel_PerformanceChartHeader: "MyK_FleetChartLabel_PerformanceChartHeader",
    MyK_FleetLabel_ShowingResultText_Without_Cautions:
        "MyK_FleetLabel_ShowingResultText_Without_Cautions",
    MyK_Myhealth_TreeView_Placeholder: "MyK_Myhealth_TreeView_Placeholder",
    MyK_Myhealth_TreeView_SelectAll: "MyK_Myhealth_TreeView_SelectAll",
    MyK_Myhealth_SortBY: "MyK_Myhealth_SortBY",
    MyK_Myhealth_FIlterBy: "MyK_Myhealth_FIlterBy",
    MyK_ChartLabel_SMRHours: "MyK_ChartLabel_SMRHours",
    MyK_Select: "MyK_Select",
    MyK_Title_DailyView: "MyK_Title_DailyView",
    MyK_Title_MonthlyView: "MyK_Title_MonthlyView",
    MyK_BreadcrumbHeader_Home: "MyK_BreadcrumbHeader_Home",
    MyK_FleetLabel_Question: "MyK_FleetLabel_Question",
    MyK_FleetLabel_QuestionAnswer: "MyK_FleetLabel_QuestionAnswer",
    MyK_Menu_MyFleet_API_Connected: "MyK_Menu_MyFleet_API_Connected",
    MyK_Menu_MyFleet_Open_FC_Count: "MyK_Menu_MyFleet_Open_FC_Count",
    MyK_Label_NotificationRecommendation: "MyK_Label_NotificationRecommendation",
    MyK_Grid_Validation_Msg_MR_Quantity: "MyK_Grid_Validation_Msg_MR_Quantity",
    MyK_Grid_Validation_Msg_MR_ServiceInterval: "MyK_Grid_Validation_Msg_MR_ServiceInterval",
    MyK_Grid_Validation_Msg_MR_MaximumLength_50: "MyK_Grid_Validation_Msg_MR_MaximumLength_50",
    MyK_Grid_Validation_Msg_MR_MaximumLength_255: "MyK_Grid_Validation_Msg_MR_MaximumLength_255",
    MyK_Grid_Validation_Msg_MR_SettledInterval: "MyK_Grid_Validation_Msg_MR_SettledInterval",
    MyK_Grid_Validation_Msg_MR_SMR_MinMax: "MyK_Grid_Validation_Msg_MR_SMR_MinMax",
    MyK_Label_ErrorMessage: "MyK_Label_ErrorMessage",
    MyK_Fleet_Filters_Enabled: "MyK_Fleet_Filters_Enabled",
    MyK_Label_SearchBy_Model_Serial: "MyK_Label_SearchBy_Model_Serial",
    MyK_Label_Go: "MyK_Label_Go",
    Myk_Label_App_Notification: "Myk_Label_App_Notification",
    Myk_Label_Schedule_Report: "Myk_Label_Schedule_Report",
    Myk_Label_Fleet_Notification: "Myk_Label_Fleet_Notification",
    MyK_Label_Select_Month: "MyK_Label_Select_Month",
    Myk_Label_SessionHeading: "Myk_Label_SessionHeading",
    Myk_Label_SessionMessage: "Myk_Label_SessionMessage",
    Myk_Label_SessionSignIn: "Myk_Label_SessionSignIn",
    Myk_Label_SessionSignOut: "Myk_Label_SessionSignOut",
    Myk_Label_SessionQuestion: "Myk_Label_SessionQuestion",
    MyK_Label_UsageHours: "MyK_Label_UsageHours",
    MyK_Label_FluidConsumption: "MyK_Label_FluidConsumption",
    MyK_Label_ModeHours: "MyK_Label_ModeHours",
    MyK_Fleet_Filters_Validation: "MyK_Fleet_Filters_Validation",
    MyK_UtilGrid_DateMonthYear: "MyK_UtilGrid_DateMonthYear",
    MyK_QuoteNotification_Text: "MyK_QuoteNotification_Text",
    MyK_QuoteNotification_SignalRText: "MyK_QuoteNotification_SignalRText",

    MyK_AppNotificationLabel_ClickSerialNumberToView: "MyK_AppNotificationLabel_ClickSerialNumberToView",
    MyK_AppNotificationLabel_NotificationChannel: "MyK_AppNotificationLabel_NotificationChannel",
    MyK_AppNotificationLabel_DeliveredThroughChannel: "MyK_AppNotificationLabel_DeliveredThroughChannel",
    MyK_AppNotificationLabel_FCLetter: "MyK_AppNotificationLabel_FCLetter",
    MyK_AppNotificationLabel_ClickToChangeUnread: "MyK_AppNotificationLabel_ClickToChangeUnread",
    MyK_AppNotificationLabel_ClickToChangeRead: "MyK_AppNotificationLabel_ClickToChangeRead",
    MyK_AppNotificationLabel_MarkAllAsRead: "MyK_AppNotificationLabel_MarkAllAsRead",
    MyK_AppNotificationLabel_MachinesMovedIn: "MyK_AppNotificationLabel_MachinesMovedIn",
    MyK_AppNotificationLabel_MachinesMovedOut: "MyK_AppNotificationLabel_MachinesMovedOut",
    MyK_AppNotificationLabel_ClickViewMachineMovedIn: "MyK_AppNotificationLabel_ClickViewMachineMovedIn",
    MyK_AppNotificationLabel_ClickViewMachineMovedOut: "MyK_AppNotificationLabel_ClickViewMachineMovedOut",
    MyK_AppNotificationLabel_All: "MyK_AppNotificationLabel_All",
    Myk_Label_Operation_Report: "Myk_Label_Operation_Report",
    Myk_Label_Fleet_Reports: "Myk_Label_Fleet_Reports",
    Myk_Label_Open_Mandatory_FC_Report: "Myk_Label_Open_Mandatory_FC_Report",
    Myk_Label_Report_Maintenance: "Myk_Label_Report_Maintenance",
    Myk_Label_Report_Note: "Myk_Label_Report_Note",
    Myk_Label_Fleet_Report_Note: "Myk_Label_Fleet_Report_Note",
    Myk_Label_Open_FC_Report_Note: "Myk_Label_Open_FC_Report_Note",
    Myk_Label_Report_Name: "Myk_Label_Report_Name",
    Myk_Label_Report_Unit_of_Measure: "Myk_Label_Report_Unit_of_Measure",
    Myk_Label_Report_Email: "Myk_Label_Report_Email",
    Myk_Label_Report_Email_Placeholder: "Myk_Label_Report_Email_Placeholder",
    Myk_Label_Machine_Listing: "Myk_Label_Machine_Listing",
    Myk_Label_Search_By_Model_Serial_Unit: "Myk_Label_Search_By_Model_Serial_Unit",
    Myk_Label_Report_Language: "Myk_Label_Report_Language",
    Myk_Label_Select_Dealer: "Myk_Label_Select_Dealer",
    Myk_Label_Select_Customer: "Myk_Label_Select_Customer",
    Myk_Label_Select_Location: "Myk_Label_Select_Location",
    Myk_Label_Select_Distributor: "Myk_Label_Select_Distributor",
    Myk_Label_Search_Dealer: "Myk_Label_Search_Dealer",
    Myk_Label_Search_Customer: "Myk_Label_Search_Customer",
    Myk_Label_Search_Location: "Myk_Label_Search_Location",
    MyK_AppNotificationLabel_Unread: "MyK_AppNotificationLabel_Unread",
    MyK_AppNotificationLabel_ScheduleAlert: "MyK_AppNotificationLabel_ScheduleAlert",
    MyK_AppNotificationLabel_AddNotes: "MyK_AppNotificationLabel_AddNotes",
    MyK_AppNotificationLabel_SMS: "MyK_AppNotificationLabel_SMS",
    MyK_AppNotificationLabel_Email: "MyK_AppNotificationLabel_Email",
    MyK_AppNotificationLabel_WebApp: "MyK_AppNotificationLabel_WebApp",
    MyK_AppNotificationLabel_MobileApp: "MyK_AppNotificationLabel_MobileApp",
    MyK_AppNotificationLabel_ViewMachines: "MyK_AppNotificationLabel_ViewMachines",
    MyK_AppNotificationLabel_Attachment: "MyK_AppNotificationLabel_Attachment",
    Myk_Label_Schedule_Report_Success: "Myk_Label_Schedule_Report_Success",
    Myk_Label_Schedule_Report_Error: "Myk_Label_Schedule_Report_Error",
    MyK_Info_UnauthroizedUserMsg: "MyK_Info_UnauthroizedUserMsg",
    MyK_Info_MachineAccessDenied: "MyK_Info_MachineAccessDenied",
    MyK_Info_AccessDenied: "MyK_Info_AccessDenied",
    MyK_Info_Information: "MyK_Info_Information",
    MyK_Info_MarkAsCompleteConfirmationMessage: "MyK_Info_MarkAsCompleteConfirmationMessage",
    MyK_EU_FCGrid_Mileage: "MyK_EU_FCGrid_Mileage",
    MyK_EU_KomatsuCareBrochure_EN: "MyK_EU_KomatsuCareBrochure_EN",
    MyK_EU_KomatsuCareBrochure_DE: "MyK_EU_KomatsuCareBrochure_DE",
    MyK_Profile_ProfileSettings: "MyK_Profile_ProfileSettings",
    MyK_Profile_Configuration: "MyK_Profile_Configuration",
    MyK_Profile_UserProfile: "MyK_Profile_UserProfile",
    MyK_Profile_FirstName: "MyK_Profile_FirstName",
    MyK_Profile_LastName: "MyK_Profile_LastName",
    MyK_Profile_JobTitle: "MyK_Profile_JobTitle",
    MyK_Profile_PrimaryResponsibility: "MyK_Profile_PrimaryResponsibility",
    MyK_Profile_Department: "MyK_Profile_Department",
    MyK_Profile_PrimaryPhNumber: "MyK_Profile_PrimaryPhNumber",
    MyK_Profile_SecondaryPhNumber: "MyK_Profile_SecondaryPhNumber",
    MyK_Profile_PreferredLanguage: "MyK_Profile_PreferredLanguage",
    MyK_Profile_LanguageSpoken: "MyK_Profile_LanguageSpoken",
    MyK_Profile_LanguageAlert: "MyK_Profile_LanguageAlert",
    MyK_Profile_LabelUpdate: "MyK_Profile_LabelUpdate",
    MyK_Profile_UnitMeasure: "MyK_Profile_UnitMeasure",
    MyK_Profile_LanguageLocation: "MyK_Profile_LanguageLocation",
    MyK_Profile_UploadPhoto: "MyK_Profile_UploadPhoto",
    MyK_Profile_DocumentLanguage: "MyK_Profile_DocumentLanguage",
    MyK_Profile_DateFormat: "MyK_Profile_DateFormat",
    MyK_Profile_LanguageConfirm: "MyK_Profile_LanguageConfirm",
    MyK_Documents_Filter: "MyK_Documents_Filter",
    MyK_Documents_NoDataFound: "MyK_Documents_NoDataFound",
    MyK_Documents_SearchBy: "MyK_Documents_SearchBy",
    MyK_Documents_GlobalSearch: "MyK_Documents_GlobalSearch",
    MyK_Documents_Search: "MyK_Documents_Search",
    MyK_Documents_Previous: "MyK_Documents_Previous",
    MyK_Documents_Next: "MyK_Documents_Next",
    MyK_Documents_Default: "MyK_Documents_Default",
    MyK_Documents_Favorites: "MyK_Documents_Favorites",
    MyK_Documents_AddFavorites: "MyK_Documents_AddFavorites",
    MyK_Documents_RemoveFavorites: "MyK_Documents_RemoveFavorites",
    MyK_Documents_ProductType: "MyK_Documents_ProductType",
    MyK_Documents_ViewParts: "MyK_Documents_ViewParts",
    MyK_Documents_ViewPdf: "MyK_Documents_ViewPdf",
    MyK_Documents_DocumentNo: "MyK_Documents_DocumentNo",
    MyK_Documents_Remove: "MyK_Documents_Remove",
    MyK_Documents_FavoritesConfirm: "MyK_Documents_FavoritesConfirm",
    MyK_Profile_ImageAlert: "MyK_Profile_ImageAlert",
    MyK_Profile_Warning: "MyK_Profile_Warning",
    MyK_Profile_Message: "MyK_Profile_Message",
    MyK_Profile_Confirmation: "MyK_Profile_Confirmation",
    MyK_BreadcrumbHeader_PartsStore: "MyK_BreadcrumbHeader_PartsStore",
    MyK_BreadcrumbHeader_Cart: "MyK_BreadcrumbHeader_Cart",
    MyK_BreadcrumbHeader_Checkout: "MyK_BreadcrumbHeader_Checkout",
    MyK_Label_ShoppingCart_Update: "MyK_Label_ShoppingCart_Update",
    MyK_Label_ShoppingCart_Currently_Viewing: "MyK_Label_ShoppingCart_Currently_Viewing",
    MyK_Label_ShoppingCart_Select_Branch: "MyK_Label_ShoppingCart_Select_Branch",
    MyK_Label_ShoppingCart_Add_Part_Number: "MyK_Label_ShoppingCart_Add_Part_Number",
    MyK_Label_ShoppingCart: "MyK_Label_ShoppingCart",
    MyK_Label_ShoppingCart_ItemInCart: "MyK_Label_ShoppingCart_ItemInCart",
    MyK_Label_ShoppingCart_ItemsInCart: "MyK_Label_ShoppingCart_ItemsInCart",
    MyK_Label_ShoppingCart_Cart_Last_Refreshed: "MyK_Label_ShoppingCart_Cart_Last_Refreshed",
    MyK_Label_ShoppingCart_Refresh_Cart: "MyK_Label_ShoppingCart_Refresh_Cart",
    MyK_Label_ShoppingCart_Refresh_Availability: "MyK_Label_ShoppingCart_Refresh_Availability",
    MyK_Label_ShoppingCart_Part: "MyK_Label_ShoppingCart_Part",
    MyK_Label_ShoppingCart_Manufacturer: "MyK_Label_ShoppingCart_Manufacturer",
    MyK_Label_ShoppingCart_Qty: "MyK_Label_ShoppingCart_Qty",
    MyK_Label_ShoppingCart_Add: "MyK_Label_ShoppingCart_Add",
    MyK_Label_ShoppingCart_Part_Number_Required: "MyK_Label_ShoppingCart_Part_Number_Required",
    MyK_Label_ShoppingCart_Manufacture_Required: "MyK_Label_ShoppingCart_Manufacture_Required",
    MyK_Label_ShoppingCart_Quantity_Validation: "MyK_Label_ShoppingCart_Quantity_Validation",
    MyK_Label_ShoppingCart_Add_Part_Success_Msg: "MyK_Label_ShoppingCart_Add_Part_Success_Msg",
    MyK_Label_ShoppingCart_Add_Part_Error_Msg: "MyK_Label_ShoppingCart_Add_Part_Error_Msg",
    MyK_Label_ShoppingCart_Show_Cart_Tools_Menu: "MyK_Label_ShoppingCart_Show_Cart_Tools_Menu",
    MyK_Label_ShoppingCart_Hide_Cart_Tools_Menu: "MyK_Label_ShoppingCart_Hide_Cart_Tools_Menu",
    MyK_Label_ShoppingCart_Select_Machine: "MyK_Label_ShoppingCart_Select_Machine",
    MyK_Label_ShoppingCart_Select_Manufacturer: "MyK_Label_ShoppingCart_Select_Manufacturer",
    MyK_Label_ShoppingCart_Return_Policy: "MyK_Label_ShoppingCart_Return_Policy",
    MyK_Label_ShoppingCart_Back: "MyK_Label_ShoppingCart_Back",
    MyK_Label_ShoppingCart_Freight_Calculator: "MyK_Label_ShoppingCart_Freight_Calculator",
    MyK_Label_ShoppingCart_Save_Cart_as_Parts_List: "MyK_Label_ShoppingCart_Save_Cart_as_Parts_List",
    MyK_Label_ShoppingCart_Shopping_List_Name: "MyK_Label_ShoppingCart_Shopping_List_Name",
    MyK_Label_ShoppingCart_Shared_Parts_List_Customer: "MyK_Label_ShoppingCart_Shared_Parts_List_Customer",
    MyK_Label_ShoppingCart_Shared_Parts_List_User: "MyK_Label_ShoppingCart_Shared_Parts_List_User",
    MyK_Label_ShoppingCart_Shared_Parts_Order_Files_Upload: "MyK_Label_ShoppingCart_Shared_Parts_Order_Files_Upload",
    MyK_Label_ShoppingCart_Select_File_To_Upload: "MyK_Label_ShoppingCart_Select_File_To_Upload",
    MyK_Label_ShoppingCart_Multiple_File_Upload: "MyK_Label_ShoppingCart_Multiple_File_Upload",
    MyK_Label_ShoppingCart_Shared_Parts_List: "MyK_Label_ShoppingCart_Shared_Parts_List",
    MyK_Label_ShoppingCart_Dealer_Availability: "MyK_Label_ShoppingCart_Dealer_Availability",
    MyK_Label_ShoppingCart_Share: "MyK_Label_ShoppingCart_Share",
    MyK_Label_ShoppingCart_Quote: "MyK_Label_ShoppingCart_Quote",
    MyK_Label_ShoppingCart_Return_Policy_Text: "MyK_Label_ShoppingCart_Return_Policy_Text",
    MyK_Label_ShoppingCart_Quantity: "MyK_Label_ShoppingCart_Quantity",
    MyK_Label_ShoppingCart_Saved_Parts_List: "MyK_Label_ShoppingCart_Saved_Parts_List",
    MyK_Label_ShoppingCart_Upload_Parts_List: "MyK_Label_ShoppingCart_Upload_Parts_List",
    MyK_Label_ShoppingCart_Machine_Model: "MyK_Label_ShoppingCart_Machine_Model",
    MyK_Label_ShoppingCart_Returnable: "MyK_Label_ShoppingCart_Returnable",
    MyK_Label_ShoppingCart_Availability: "MyK_Label_ShoppingCart_Availability",
    MyK_Label_ShoppingCart_Order_By_CutOff: "MyK_Label_ShoppingCart_Order_By_CutOff",
    MyK_Label_ShoppingCart_See_Recommedations: "MyK_Label_ShoppingCart_See_Recommedations",
    MyK_Label_ShoppingCart_Unit_Price: "MyK_Label_ShoppingCart_Unit_Price",
    MyK_Label_ShoppingCart_ItemTotal: "MyK_Label_ShoppingCart_ItemTotal",
    MyK_Label_ShoppingCart_Estimate_Shipping: "MyK_Label_ShoppingCart_Estimate_Shipping",
    MyK_Label_ShoppingCart_Deselect_All: "MyK_Label_ShoppingCart_Deselect_All",
    MyK_Label_ShoppingCart_Select_All: "MyK_Label_ShoppingCart_Select_All",
    MyK_Label_ShoppingCart_Download: "MyK_Label_ShoppingCart_Download",
    MyK_Label_ShoppingCart_Expand_Collapse: "MyK_Label_ShoppingCart_Expand_Collapse",
    MyK_Label_ShoppingCart_Maintenance_Part_List: "MyK_Label_ShoppingCart_Maintenance_Part_List",
    MyK_Label_ShoppingCart_Update_Part_Success_Msg: "MyK_Label_ShoppingCart_Update_Part_Success_Msg",
    MyK_Label_ShoppingCart_Update_Part_Error_Msg: "MyK_Label_ShoppingCart_Update_Part_Error_Msg",
    MyK_Label_ShoppingCart_Promo_Item_Summary: "MyK_Label_ShoppingCart_Promo_Item_Summary",
    MyK_Label_ShoppingCart_Promo_Remove: "MyK_Label_ShoppingCart_Promo_Remove",
    MyK_Label_ShoppingCart_Promo_Rewards: "MyK_Label_ShoppingCart_Promo_Rewards",
    MyK_Label_ShoppingCart_Promo_Your_Reward_Codes: "MyK_Label_ShoppingCart_Promo_Your_Reward_Codes",
    MyK_Label_ShoppingCart_Promo: "MyK_Label_ShoppingCart_Promo",
    MyK_Label_ShoppingCart_Promo_Apply: "MyK_Label_ShoppingCart_Promo_Apply",
    MyK_Label_ShoppingCart_Promo_Estimate_Total_Shipping: "MyK_Label_ShoppingCart_Promo_Estimate_Total_Shipping",
    MyK_Label_ShoppingCart_Promo_Close_All: "MyK_Label_ShoppingCart_Promo_Close_All",
    MyK_Label_ShoppingCart_Promo_Expand_All: "MyK_Label_ShoppingCart_Promo_Expand_All",
    MyK_Label_ShoppingCart_Promo_Total: "MyK_Label_ShoppingCart_Promo_Total",
    MyK_Label_ShoppingCart_Promo_SubTotal: "MyK_Label_ShoppingCart_Promo_SubTotal",
    MyK_Label_ShoppingCart_Promo_Est_Pre_Tax_Total: "MyK_Label_ShoppingCart_Promo_Est_Pre_Tax_Total",
    MyK_Label_ShoppingCart_Promo_Excluding_Shipping: "MyK_Label_ShoppingCart_Promo_Excluding_Shipping",
    MyK_Label_ShoppingCart_Promo_Checkout: "MyK_Label_ShoppingCart_Promo_Checkout",
    MyK_Label_ShoppingCart_Promo_Next: "MyK_Label_ShoppingCart_Promo_Next",
    MyK_Label_ShoppingCart_Promo_See_Recommendations_Based_on_Cart: "MyK_Label_ShoppingCart_Promo_See_Recommendations_Based_on_Cart",
    MyK_Label_ShoppingCart_Promo_Parts_Credit: "MyK_Label_ShoppingCart_Promo_Parts_Credit",
    MyK_Label_ShoppingCart_Promo_Available: "MyK_Label_ShoppingCart_Promo_Available",
    MyK_Label_ShoppingCart_Promo_Apply_Credit: "MyK_Label_ShoppingCart_Promo_Apply_Credit",
    MyK_Label_ShoppingCart_Promo_Select_Code: "MyK_Label_ShoppingCart_Promo_Select_Code",
    MyK_Label_ShoppingCart_Promo_Estimate_Shipping: "MyK_Label_ShoppingCart_Promo_Estimate_Shipping",
    MyK_Label_ShoppingCart_Promo_Freight_Calculator: "MyK_Label_ShoppingCart_Promo_Freight_Calculator",
    MyK_Label_ShoppingCart_Promo_GetItemSummaryDetails_Success_Msg: "MyK_Label_ShoppingCart_Promo_GetItemSummaryDetails_Success_Msg",
    MyK_Label_ShoppingCart_Promo_GetItemSummaryDetails_Error_Msg: "MyK_Label_ShoppingCart_Promo_GetItemSummaryDetails_Error_Msg",
    MyK_Label_ShoppingCart_Promo_DeletePromoCode_Success_Msg: "MyK_Label_ShoppingCart_Promo_DeletePromoCode_Success_Msg",
    MyK_Label_ShoppingCart_Promo_DeletePromoCode_Error_Msg: "MyK_Label_ShoppingCart_Promo_DeletePromoCode_Error_Msg",
    MyK_Label_ShoppingCart_Promo_GetAppliedPromoDetails_Success_Msg: "MyK_Label_ShoppingCart_Promo_GetAppliedPromoDetails_Success_Msg",
    MyK_Label_ShoppingCart_Promo_GetAppliedPromoDetails_Error_Msg: "MyK_Label_ShoppingCart_Promo_GetAppliedPromoDetails_Error_Msg",
    MyK_Label_ShoppingCart_Promo_Original_Unit_Price: "MyK_Label_ShoppingCart_Promo_Original_Unit_Price",
    MyK_Label_ShoppingCart_Promo_Code_Applied: "MyK_Label_ShoppingCart_Promo_Code_Applied",
    MyK_Label_ShoppingCart_Promo_Unit_Price: "MyK_Label_ShoppingCart_Promo_Unit_Price",
    MyK_Label_ShoppingCart_Promo_Price: "MyK_Label_ShoppingCart_Promo_Price",
    MyK_Label_ShoppingCart_Promo_Discount_Applied: "MyK_Label_ShoppingCart_Promo_Discount_Applied",
    MyK_Label_ShoppingCart_Promo_Quantity_In_Cart: "MyK_Label_ShoppingCart_Promo_Quantity_In_Cart",
    MyK_Label_ShoppingCart_Promo_Total_Discount: "MyK_Label_ShoppingCart_Promo_Total_Discount",
    MyK_Label_ShoppingCart_Promo_Part_Number: "MyK_Label_ShoppingCart_Promo_Part_Number",
    MyK_Label_ShoppingCart_Promo_Remove_Confirmation: "MyK_Label_ShoppingCart_Promo_Remove_Confirmation",
    MyK_Label_ShoppingCart_Item_Total: "MyK_Label_ShoppingCart_Item_Total",
    MyK_Label_ShoppingCart_Promo_Valid_Success_Msg: "MyK_Label_ShoppingCart_Promo_Valid_Success_Msg",
    MyK_Label_ShoppingCart_Promo_Invalid_Error_Msg: "MyK_Label_ShoppingCart_Promo_Invalid_Error_Msg",
    MyK_Label_ShoppingCart_Promo_Apply_Error_Msg: "MyK_Label_ShoppingCart_Promo_Apply_Error_Msg",
    MyK_Label_ShoppingCart_Promo_Remove_Confirmation_Msg: "MyK_Label_ShoppingCart_Promo_Remove_Confirmation_Msg",
    MyK_Label_ShoppingCart_Recommended_Based_On_Cart: "MyK_Label_ShoppingCart_Recommended_Based_On_Cart",
    MyK_Label_ShoppingCart_Products: "MyK_Label_ShoppingCart_Products",
    MyK_Label_ShoppingCart_Product_Recommendation: "MyK_Label_ShoppingCart_Product_Recommendation",
    MyK_Label_ShoppingCart_Pricing_Availability: "MyK_Label_ShoppingCart_Pricing_Availability",
    MyK_Label_ShoppingCart_Add_To_List: "MyK_Label_ShoppingCart_Add_To_List",
    MyK_Label_ShoppingCart_Bookmarked_Parts: "MyK_Label_ShoppingCart_Bookmarked_Parts",
    MyK_Label_ShoppingCart_Machines: "MyK_Label_ShoppingCart_Machines",
    MyK_Label_ShoppingCart_Machines_Part_List_Name: "MyK_Label_ShoppingCart_Machines_Part_List_Name",
    MyK_Label_ShoppingCart_Creation_Date: "MyK_Label_ShoppingCart_Creation_Date",
    MyK_Label_ShoppingCart_Type: "MyK_Label_ShoppingCart_Type",
    MyK_Label_ShoppingCart_Parts_For_Shopping_Cart: "MyK_Label_ShoppingCart_Parts_For_Shopping_Cart",
    MyK_Label_ShoppingCart_PartList_Add_Part_Number: "MyK_Label_ShoppingCart_PartList_Add_Part_Number",
    MyK_Label_ShoppingCart_Recent_PartList: "MyK_Label_ShoppingCart_Recent_PartList",
    MyK_Label_ShoppingCart_Add_PartList: "MyK_Label_ShoppingCart_Add_PartList",
    MyK_Label_SC_Add_PartList_Validation_OneItem: "MyK_Label_SC_Add_PartList_Validation_OneItem",
    MyK_Label_SC_Add_PartList_Validation_OnePart: "MyK_Label_SC_Add_PartList_Validation_OnePart",
    MyK_Label_SC_Add_PartList_Validation_OnePartList: "MyK_Label_SC_Add_PartList_Validation_OnePartList",
    MyK_Label_SC_Credit_Limit_Warning: "MyK_Label_SC_Credit_Limit_Warning",
    MyK_Label_SC_Credit_Card_Order: "MyK_Label_SC_Credit_Card_Order",
    MyK_Label_SC_Purchase_Via_Dealer_Credit_Account: "MyK_Label_SC_Purchase_Via_Dealer_Credit_Account",
    MyK_Label_SC_Cash_On_Delivery: "MyK_Label_SC_Cash_On_Delivery",
    MyK_Label_SC_PO_Number: "MyK_Label_SC_PO_Number",
    MyK_Label_SC_Billing_Address: "MyK_Label_SC_Billing_Address",
    MyK_Label_SC_Same_As_Shipping_Address: "MyK_Label_SC_Same_As_Shipping_Address",
    MyK_Label_SC_CreditCard_Name: "MyK_Label_SC_CreditCard_Name",
    MyK_Label_SC_CreditCard_Street_Address: "MyK_Label_SC_CreditCard_Street_Address",
    MyK_Label_SC_CreditCard_City: "MyK_Label_SC_CreditCard_City",
    MyK_Label_SC_CreditCard_State: "MyK_Label_SC_CreditCard_State",
    MyK_Label_SC_CreditCard_Country: "MyK_Label_SC_CreditCard_Country",
    MyK_Label_SC_CreditCard_Zone: "MyK_Label_SC_CreditCard_Zone",
    MyK_Label_SC_Partlist_Save_Success: "MyK_Label_SC_Partlist_Save_Success",
    MyK_Label_SC_Partlist_Save_Error: "MyK_Label_SC_Partlist_Save_Error",
    MyK_Label_SC_CreditCard_Save_For_Future_Use: "MyK_Label_SC_CreditCard_Save_For_Future_Use",
    MyK_Label_ShoppingCart_Order_History: "MyK_Label_ShoppingCart_Order_History",
    MyK_Label_ShoppingCart_Apply_Komatsu_Credit: "MyK_Label_ShoppingCart_Apply_Komatsu_Credit",
    MyK_Label_ShoppingCart_Komatsu_Credit_Available: "MyK_Label_ShoppingCart_Komatsu_Credit_Available",
    MyK_Label_ShoppingCart_Apply: "MyK_Label_ShoppingCart_Apply",
    MyK_Label_ShoppingCart_Komatsu_Credit_Applied: "MyK_Label_ShoppingCart_Komatsu_Credit_Applied",
    MyK_Label_ShoppingCart_Sub_Total: "MyK_Label_ShoppingCart_Sub_Total",
    MyK_Label_ShoppingCart_Remaining_Komatsu_credit_Balance: "MyK_Label_ShoppingCart_Remaining_Komatsu_credit_Balance",
    MyK_Label_ShoppingCart_Continue: "MyK_Label_ShoppingCart_Continue",
    MyK_Label_ShoppingCart_Komatsu_Credit_Eligible: "MyK_Label_ShoppingCart_Komatsu_Credit_Eligible",
    MyK_Label_ShoppingCart_onApplyCredit_Success_Msg: "MyK_Label_ShoppingCart_onApplyCredit_Success_Msg",
    MyK_Label_ShoppingCart_onApplyCredit_Error_Msg: "MyK_Label_ShoppingCart_onApplyCredit_Error_Msg",
    MyK_Label_ShoppingCart_getAvailablePartsCredits_Success_Msg: "MyK_Label_ShoppingCart_getAvailablePartsCredits_Success_Msg",
    MyK_Label_ShoppingCart_getAvailablePartsCredits_Error_Msg: "MyK_Label_ShoppingCart_getAvailablePartsCredits_Error_Msg",
    MyK_Label_ShoppingCart_Promo_GetCustomerCreditInfo_Success_Msg: "MyK_Label_ShoppingCart_Promo_GetCustomerCreditInfo_Success_Msg",
    MyK_Label_ShoppingCart_Promo_GetCustomerCreditInfo_Error_Msg: "MyK_Label_ShoppingCart_Promo_GetCustomerCreditInfo_Error_Msg",
    MyK_Label_ShoppingCart_Komatsu_Credit_Confirmation: "MyK_Label_ShoppingCart_Komatsu_Credit_Confirmation",
    MyK_Label_ShoppingCart_Komatsu_Credit_Confirmation_Msg_Part1: "MyK_Label_ShoppingCart_Komatsu_Credit_Confirmation_Msg_Part1",
    MyK_Label_ShoppingCart_Komatsu_Credit_Confirmation_Msg_Part2: "MyK_Label_ShoppingCart_Komatsu_Credit_Confirmation_Msg_Part2",
    MyK_Label_ShoppingCart_Credit_Usage: "MyK_Label_ShoppingCart_Credit_Usage",
    MyK_Label_ShoppingCart_Credit_Amount: "MyK_Label_ShoppingCart_Credit_Amount",
    MyK_Label_ShoppingCart_Balance: "MyK_Label_ShoppingCart_Balance",
    MyK_Label_ShoppingCart_Duration: "MyK_Label_ShoppingCart_Duration",
    MyK_Label_ShoppingCart_MyQuotes: "MyK_Label_ShoppingCart_MyQuotes",
    MyK_Label_ShoppingCart_SharedQuotes: "MyK_Label_ShoppingCart_SharedQuotes",
    MyK_Label_ShoppingCart_Archive: "MyK_Label_ShoppingCart_Archive",
    MyK_Label_ShoppingCart_SaveQuote: "MyK_Label_ShoppingCart_SaveQuote",
    MyK_Label_ShoppingCart_Action: "MyK_Label_ShoppingCart_Action",
    MyK_Label_ShoppingCart_Quote_Name: "MyK_Label_ShoppingCart_Quote_Name",
    MyK_Label_ShoppingCart_No_of_Parts: "MyK_Label_ShoppingCart_No_of_Parts",
    MyK_Label_ShoppingCart_Created_By: "MyK_Label_ShoppingCart_Created_By",
    MyK_Label_ShoppingCart_Shared_With: "MyK_Label_ShoppingCart_Shared_With",
    MyK_Label_ShoppingCart_Created_Date: "MyK_Label_ShoppingCart_Created_Date",
    MyK_Label_ShoppingCart_getQuotesDetailData_Error_Msg: "MyK_Label_ShoppingCart_getQuotesDetailData_Error_Msg",
    MyK_Label_ShoppingCart_Get_Promo_Error_Msg: 'MyK_Label_ShoppingCart_Get_Promo_Error_Msg',
    MyK_Label_ShoppingCart_Promo_Applied: "MyK_Label_ShoppingCart_Promo_Applied",
    MyK_Label_ShoppingCart_OneTime_Promo_Warning_Msg1: "MyK_Label_ShoppingCart_OneTime_Promo_Warning_Msg1",
    MyK_Label_ShoppingCart_OneTime_Promo_Warning_Msg2: "MyK_Label_ShoppingCart_OneTime_Promo_Warning_Msg2",
    MyK_Label_ShoppingCart_Greater_Than_Zero: "MyK_Label_ShoppingCart_Greater_Than_Zero",
    MyK_Label_ShoppingCart_Enter_Lower_Amount: "MyK_Label_ShoppingCart_Enter_Lower_Amount",
    MyK_Label_ShoppingCart_Select_Komatsu_Credit: "MyK_Label_ShoppingCart_Select_Komatsu_Credit",
    MyK_Label_ShoppingCart_Select_Additional_Credit: "MyK_Label_ShoppingCart_Select_Additional_Credit",
    MyK_Label_ShoppingCart_Total: "MyK_Label_ShoppingCart_Total",
    MyK_Label_ShoppingCart_Parts_Credit_Applied: "MyK_Label_ShoppingCart_Parts_Credit_Applied",
    MyK_Label_ShoppingCart_Promo_Discount_Total: "MyK_Label_ShoppingCart_Promo_Discount_Total",
    MyK_Label_ShoppingCart_Back_to_Quote: "MyK_Label_ShoppingCart_Back_to_Quote",
    MyK_Label_ShoppingCart_Quote_Number: "MyK_Label_ShoppingCart_Quote_Number",
    MyK_Label_ShoppingCart_Shared_Date: "MyK_Label_ShoppingCart_Shared_Date",
    MyK_Grid_Machine: "MyK_Grid_Machine",
    MyK_Label_ShoppingCart_Title: "MyK_Label_ShoppingCart_Title",
    MyK_Label_ShoppingCart_View_Date: "MyK_Label_ShoppingCart_View_Date",
    MyK_Label_ShoppingCart_onContinuePartsCredit_Success_Msg: "MyK_Label_ShoppingCart_onContinuePartsCredit_Success_Msg",
    MyK_Label_ShoppingCart_onContinuePartsCredit_Error_Msg: "MyK_Label_ShoppingCart_onContinuePartsCredit_Error_Msg",
    MyK_Info_EnterMultipleEmailText: "MyK_Info_EnterMultipleEmailText",
    MyK_Label_SC_Quote_Selection_Validation: "MyK_Label_SC_Quote_Selection_Validation",
    MyK_Label_SC_Archive_Quote_Confirm_Msg: "MyK_Label_SC_Archive_Quote_Confirm_Msg",
    MyK_Label_SC_Archive_Quote: "MyK_Label_SC_Archive_Quote",
    MyK_Label_SC_Quote_Parts_Selection_Validation: "MyK_Label_SC_Quote_Parts_Selection_Validation",
    MyK_Label_SC_Delete_Quote_Confirm_Msg: "MyK_Label_SC_Delete_Quote_Confirm_Msg",
    MyK_Label_SC_Delete_Quote: "MyK_Label_SC_Delete_Quote",
    MyK_Label_ShoppingCart_deletePartService_Success_Msg: "MyK_Label_ShoppingCart_deletePartService_Success_Msg",
    MyK_Label_ShoppingCart_deletePartService_Error_Msg: "MyK_Label_ShoppingCart_deletePartService_Error_Msg",
    MyK_Label_SC_Quote_Confirmation: "MyK_Label_SC_Quote_Confirmation",
    MyK_Label_SC_Quote_AddtoCart_Confirm_Msg: "MyK_Label_SC_Quote_AddtoCart_Confirm_Msg",
    MyK_Label_SC_Quote_Send: "MyK_Label_SC_Quote_Send",
    MyK_Label_SC_Quote_User_Email: "MyK_Label_SC_Quote_User_Email",
    MyK_Label_SC_Partlist_Decrease: "MyK_Label_SC_Partlist_Decrease",
    MyK_Label_SC_Partlist_Increase: "MyK_Label_SC_Partlist_Increase",
    MyK_Label_SC_Partlist_Cart_Empty: "MyK_Label_SC_Partlist_Cart_Empty",
    MyK_Label_SC_Partlist_Cart_Empty_Text: "MyK_Label_SC_Partlist_Cart_Empty_Text",
    MyK_Label_SC_Partlist_Cart_Bookmark_Add: "MyK_Label_SC_Partlist_Cart_Bookmark_Add",
    MyK_Label_SC_Partlist_Cart_Bookmark_Remove: "MyK_Label_SC_Partlist_Cart_Bookmark_Remove",
    MyK_Label_SC_Partlist_Cart_Bookmark_AddRemove_Error: "MyK_Label_SC_Partlist_Cart_Bookmark_AddRemove_Error",
    MyK_Label_ShoppingCart_Delete_Validation: "MyK_Label_ShoppingCart_Delete_Validation",
    MyK_Label_ShoppingCart_Save_Validation: "MyK_Label_ShoppingCart_Save_Validation",
    MyK_Label_ShoppingCart_Share_Validation: "MyK_Label_ShoppingCart_Share_Validation",
    MyK_Label_ShoppingCart_No_Records_Available: "MyK_Label_ShoppingCart_No_Records_Available",
    MyK_Label_ShoppingCart_Select_Part_Number: "MyK_Label_ShoppingCart_Select_Part_Number",
    MyK_Label_ShoppingCart_Delete_Confirmation: "MyK_Label_ShoppingCart_Delete_Confirmation",
    MyK_Label_ShoppingCart_Recommended_Based_On: "MyK_Label_ShoppingCart_Recommended_Based_On",
    MyK_Label_ShoppingCart_ArchiveQuoteService_Success_Msg: "MyK_Label_ShoppingCart_ArchiveQuoteService_Success_Msg",
    MyK_Label_ShoppingCart_ArchiveQuoteService_Error_Msg: "MyK_Label_ShoppingCart_ArchiveQuoteService_Error_Msg",
    MyK_Label_ShoppingCart_deleteQuoteService_Success_Msg: "MyK_Label_ShoppingCart_deleteQuoteService_Success_Msg",
    MyK_Label_ShoppingCart_deleteQuoteService_Error_Msg: "MyK_Label_ShoppingCart_deleteQuoteService_Error_Msg",
    MyK_Label_ShoppingCart_saveQuote_Error_Msg: "MyK_Label_ShoppingCart_saveQuote_Error_Msg",
    MyK_Label_ShoppingCart_saveQuote_Success_Msg: "MyK_Label_ShoppingCart_saveQuote_Success_Msg",
    MyK_Label_ShoppingCart_addToCartService_Success_Msg: "MyK_Label_ShoppingCart_addToCartService_Success_Msg",
    MyK_Label_ShoppingCart_addToCartService_Error_Msg: "MyK_Label_ShoppingCart_addToCartService_Error_Msg",
    MyK_Label_ShoppingCart_shareQuote_Success_Msg: "MyK_Label_ShoppingCart_shareQuote_Success_Msg",
    MyK_Label_ShoppingCart_shareQuote_Error_Msg: "MyK_Label_ShoppingCart_shareQuote_Error_Msg",
    MyK_Label_SC_Quote_Email_Required: "MyK_Label_SC_Quote_Email_Required",
    MyK_Label_SC_Quote_User_Email_Validation_Msg: "MyK_Label_SC_Quote_User_Email_Validation_Msg",
    MyK_Label_ShoppingCart_Shopping_List_Name_Is_Required: "MyK_Label_ShoppingCart_Shopping_List_Name_Is_Required",
    MyK_Label_SC_Partlist_Cart_Add_Bookmark: "MyK_Label_SC_Partlist_Cart_Add_Bookmark",
    MyK_Label_SC_Partlist_Cart_Remove_Bookmark: "MyK_Label_SC_Partlist_Cart_Remove_Bookmark",
    MyK_Label_ShoppingCart_Komatsu_Availability: "MyK_Label_ShoppingCart_Komatsu_Availability",
    MyK_Label_ShoppingCart_UnitWeight: "MyK_Label_ShoppingCart_UnitWeight",
    MyK_Email_Suggestions_Error_Msg: "MyK_Email_Suggestions_Error_Msg",
    MyK_Grid_Part_Number: "MyK_Grid_Part_Number",
    MyK_Label_ShoppingCart_SaveCart_Success_Msg: "MyK_Label_ShoppingCart_SaveCart_Success_Msg",
    MyK_Label_ShoppingCart_SaveCart_Error_Msg: "MyK_Label_ShoppingCart_SaveCart_Error_Msg",
    MyK_Label_ShoppingCart_Parts_List: "MyK_Label_ShoppingCart_Parts_List",
    MyK_Label_ShoppingCart_Parts_List_Name_Is_Required: "MyK_Label_ShoppingCart_Parts_List_Name_Is_Required",
    MyK_Label_ShoppingCart_Parts_List_Name: "MyK_Label_ShoppingCart_Parts_List_Name",
    MyK_Label_ShoppingCart_Promo_GetFulfillmenPermissionDetails_Error_Msg: "MyK_Label_ShoppingCart_Promo_GetFulfillmenPermissionDetails_Error_Msg",
    MyK_Label_ShoppingCart_DropShip_Fulfillment_PickupInfo: "MyK_Label_ShoppingCart_DropShip_Fulfillment_PickupInfo",
    MyK_Label_ShoppingCart_DropShip_Fulfillment_Branch_Info: "MyK_Label_ShoppingCart_DropShip_Fulfillment_Branch_Info",
    MyK_Label_ShoppingCart_DropShip_Fulfillment_Pickup_Select: "MyK_Label_ShoppingCart_DropShip_Fulfillment_Pickup_Select",
    MyK_Label_ShoppingCart_DropShip_Fulfillment_Willcall: "MyK_Label_ShoppingCart_DropShip_Fulfillment_Willcall",
    MyK_Label_ShoppingCart_DropShip_Fulfillment_Willcall_Info: "MyK_Label_ShoppingCart_DropShip_Fulfillment_Willcall_Info",
    MyK_Label_ShoppingCart_DropShip_Fulfillment_Pickup_Available_Now: "MyK_Label_ShoppingCart_DropShip_Fulfillment_Pickup_Available_Now",
    MyK_Label_ShoppingCart_DropShip_Fulfillment_Pickup_Available_Now_Info: "MyK_Label_ShoppingCart_DropShip_Fulfillment_Pickup_Available_Now_Info",
    MyK_Label_ShoppingCart_DropShip_Fulfillment_Pickup_Available_Now_Remainder: "MyK_Label_ShoppingCart_DropShip_Fulfillment_Pickup_Available_Now_Remainder",
    MyK_Label_ShoppingCart_DropShip_Fulfillment_Fulfill_Remainder: "MyK_Label_ShoppingCart_DropShip_Fulfillment_Fulfill_Remainder",
    MyK_Label_ShoppingCart_DropShip_Fulfillment_Shipping: "MyK_Label_ShoppingCart_DropShip_Fulfillment_Shipping",
    MyK_Label_ShoppingCart_DropShip_Fulfillment_Shipping_Info: "MyK_Label_ShoppingCart_DropShip_Fulfillment_Shipping_Info",
    MyK_Label_ShoppingCart_DropShip_Fulfillment_Additional_Pickup: "MyK_Label_ShoppingCart_DropShip_Fulfillment_Additional_Pickup",
    MyK_Label_ShoppingCart_DropShip_Fulfillment_Additional_Pickup_Info: "MyK_Label_ShoppingCart_DropShip_Fulfillment_Additional_Pickup_Info",
    MyK_Label_ShoppingCart_DropShip_Fulfillment_Shipping_Type_Info: "MyK_Label_ShoppingCart_DropShip_Fulfillment_Shipping_Type_Info",
    MyK_Label_ShoppingCart_DropShip_Fulfillment_Select_Type: 'MyK_Label_ShoppingCart_DropShip_Fulfillment_Select_Type',
    MyK_Label_ShoppingCart_DropShip_Fulfillment_Availability: "MyK_Label_ShoppingCart_DropShip_Fulfillment_Availability",
    MyK_Label_ShoppingCart_DropShip_Fulfillment_Amount: "MyK_Label_ShoppingCart_DropShip_Fulfillment_Amount",
    MyK_Label_ShoppingCart_Cart_Save_Success_Msg: "MyK_Label_ShoppingCart_Cart_Save_Success_Msg",
    MyK_Label_ShoppingCart_Cart_Save_Error_Msg: "MyK_Label_ShoppingCart_Cart_Save_Error_Msg",
    MyK_Label_ShoppingCart_DropShip_Fulfillment_Shipping_Tab: "MyK_Label_ShoppingCart_DropShip_Fulfillment_Shipping_Tab",
    MyK_Label_ShoppingCart_DropShip_Fulfillment_Dealer_Pickup_Tab: "MyK_Label_ShoppingCart_DropShip_Fulfillment_Dealer_Pickup_Tab",
    MyK_Label_ShoppingCart_Distributor_Availability: "MyK_Label_ShoppingCart_Distributor_Availability",
    MyK_Label_ShoppingCart_Dealer_Branch: "MyK_Label_ShoppingCart_Dealer_Branch",
    MyK_Label_ShoppingCart_User: "MyK_Label_ShoppingCart_User",
    MyK_Label_ShoppingCart_ShareInformation: "MyK_Label_ShoppingCart_ShareInformation",
    MyK_Label_ShoppingCart_New_User_Registration: "MyK_Label_ShoppingCart_New_User_Registration",
    MyK_Label_ShoppingCart_User_InfoIcon_Text: "MyK_Label_ShoppingCart_User_InfoIcon_Text",
    MyK_Label_ShoppingCart_Share_AllowedFile_Msg: "MyK_Label_ShoppingCart_Share_AllowedFile_Msg",
    MyK_Label_ShoppingCart_Share_FileSize_Limit_Msg: "MyK_Label_ShoppingCart_Share_FileSize_Limit_Msg",
    MyK_Label_ShoppingCart_Email_PlaceHolder: "MyK_Label_ShoppingCart_Email_PlaceHolder",
    MyK_Label_ShoppingCart_Select_Files: "MyK_Label_ShoppingCart_Select_Files",
    MyK_Label_ShoppingCart_No_File_Chosen: "MyK_Label_ShoppingCart_No_File_Chosen",
    MyK_Label_Greater_Than_Available_Credit: "MyK_Label_Greater_Than_Available_Credit",
    MyK_Label_SC_UP_CSV: "MyK_Label_SC_UP_CSV",
    MyK_Label_SC_UP_Info1_1: "MyK_Label_SC_UP_Info1_1",
    MyK_Label_SC_UP_Info2_2: "MyK_Label_SC_UP_Info2_2",
    MyK_Label_SC_UP_Info_eg: "MyK_Label_SC_UP_Info_eg",
    MyK_Label_SC_UP_Info_Mc1: "MyK_Label_SC_UP_Info_Mc1",
    MyK_Label_SC_UP_Info_Mc2: "MyK_Label_SC_UP_Info_Mc2",
    MyK_Label_SC_Up_Info_Mc3: "MyK_Label_SC_Up_Info_Mc3",
    MyK_Label_SC_Up_Info1_3: "MyK_Label_SC_Up_Info1_3",
    MyK_Label_SC_Up_Info2: "MyK_Label_SC_Up_Info2",
    MyK_Label_SC_Up_Info2_1: "MyK_Label_SC_Up_Info2_1",
    MyK_Label_SC_Up_Info2_11: "MyK_Label_SC_Up_Info2_11",
    MyK_Label_SC_Up_Info2_111: "MyK_Label_SC_Up_Info2_111",
    MyK_Label_SC_Up_Info2_112: "MyK_Label_SC_Up_Info2_112",
    MyK_Label_SC_Up_Info2_2_New: "MyK_Label_SC_Up_Info2_2_New",
    MyK_Label_SC_Up_Info2_21: "MyK_Label_SC_Up_Info2_21",
    MyK_Label_SC_Up_Info2_22: "MyK_Label_SC_Up_Info2_22",
    MyK_Label_SC_Up_Info2_23: "MyK_Label_SC_Up_Info2_23",
    MyK_Label_SC_Up_Info2_24: "MyK_Label_SC_Up_Info2_24",
    MyK_Label_SC_Up_Info2_25: "MyK_Label_SC_Up_Info2_25",
    MyK_Label_SC_Up_Clear: "MyK_Label_SC_Up_Clear",
    MyK_Label_SP_Cd_Info: "MyK_Label_SP_Cd_Info",
    MyK_Label_Enter_PromoCode: "MyK_Label_Enter_PromoCode",
    MyK_Label_ShoppingCart_No_Credits_Available: "MyK_Label_ShoppingCart_No_Credits_Available",
    MyK_Label_ShoppingCart_Dealer_Name: "MyK_Label_ShoppingCart_Dealer_Name",
    MyK_Label_ShoppingCart_Phone: "MyK_Label_ShoppingCart_Phone",
    MyK_Label_ShoppingCart_Email: "MyK_Label_ShoppingCart_Email",
    MyK_Label_SC_Clear_Msg: "MyK_Label_SC_Clear_Msg",
    MyK_Label_SC_Delete_Confirmation: "MyK_Label_SC_Delete_Confirmation",
    MyK_Label_SC_Delete_Msg: "MyK_Label_SC_Delete_Msg",
    MyK_Label_SC_UserEmail_Required: "MyK_Label_SC_UserEmail_Required",
    MyK_Info_PleaseSelectMachine: "MyK_Info_PleaseSelectMachine",
    MyK_Grid_Source: "MyK_Grid_Source",
    MyK_Label_ShoppingCart_Unavailable: "MyK_Label_ShoppingCart_Unavailable",
    MyK_Label_SC_SuperSession: "MyK_Label_SC_SuperSession",
    MyK_Label_SC_SuperSession_Info: "MyK_Label_SC_SuperSession_Info",
    MyK_Label_SC_SuperSession_Info2: "MyK_Label_SC_SuperSession_Info2",
    MyK_Label_SC_SuperSession_Info3: "MyK_Label_SC_SuperSession_Info3",
    MyK_Label_ShoppingCart_Part_One: "MyK_Label_ShoppingCart_Part_One",
    MyK_Label_ShoppingCart_Ready_By: "MyK_Label_ShoppingCart_Ready_By",
    MyK_Label_ShoppingCart_Store_Address: "MyK_Label_ShoppingCart_Store_Address",
    MyK_Label_ShoppingCart_Part_Two: "MyK_Label_ShoppingCart_Part_Two",
    MyK_Label_ShoppingCart_Shipping_Info: "MyK_Label_ShoppingCart_Shipping_Info",
    MyK_Label_ShoppingCart_Saved_Address: "MyK_Label_ShoppingCart_Saved_Address",
    MyK_Label_ShoppingCart_Manage: "MyK_Label_ShoppingCart_Manage",
    MyK_Label_ShoppingCart_Street_Address: "MyK_Label_ShoppingCart_Street_Address",
    MyK_Label_ShoppingCart_City: "MyK_Label_ShoppingCart_City",
    MyK_Label_ShoppingCart_State: "MyK_Label_ShoppingCart_State",
    MyK_Label_ShoppingCart_Country: "MyK_Label_ShoppingCart_Country",
    MyK_Label_ShoppingCart_Order_Contact: "MyK_Label_ShoppingCart_Order_Contact",
    MyK_Label_ShoppingCart_Shipping: "MyK_Label_ShoppingCart_Shipping",
    MyK_Label_ShoppingCart_Select_Shipping_Method: "MyK_Label_ShoppingCart_Select_Shipping_Method",
    Myk_Label_SC_Shipping_Info_Required_Msg: "Myk_Label_SC_Shipping_Info_Required_Msg",
    MyK_Label_ShoppingCart_Cost_Warning: "MyK_Label_ShoppingCart_Cost_Warning",
    MyK_Label_ShoppingCart_Weather_Warning: "MyK_Label_ShoppingCart_Weather_Warning",
    MyK_Label_ShoppingCart_Address1: "MyK_Label_ShoppingCart_Address1",
    MyK_Label_ShoppingCart_StreetAddress: "MyK_Label_ShoppingCart_StreetAddress",
    MyK_Label_ShoppingCart_Address2: "MyK_Label_ShoppingCart_Address2",
    MyK_Label_ShoppingCart_CompanyName: "MyK_Label_ShoppingCart_CompanyName",
    MyK_Label_ShoppingCart_Zip: "MyK_Label_ShoppingCart_Zip",
    MyK_Label_SP_Cd_RefreshRequiredWarning: "MyK_Label_SP_Cd_RefreshRequiredWarning",
    MyK_Label_ShoppingCart_FirstName: "MyK_Label_ShoppingCart_FirstName",
    MyK_Label_ShoppingCart_LastName: "MyK_Label_ShoppingCart_LastName",
    MyK_Label_ShoppingCart_Estimated_Cost: "MyK_Label_ShoppingCart_Estimated_Cost",
    MyK_Label_ShoppingCart_Shipping_Method_Req: "MyK_Label_ShoppingCart_Shipping_Method_Req",
    MyK_Label_ShoppingCart_Email_Req: "MyK_Label_ShoppingCart_Email_Req",
    MyK_Label_ShoppingCart_Email_Invalid: "MyK_Label_ShoppingCart_Email_Invalid",
    MyK_Label_ShoppingCart_Saved_Address_Req: "MyK_Label_ShoppingCart_Saved_Address_Req",
    MyK_Label_ShoppingCart_CompanyName_Req: "MyK_Label_ShoppingCart_CompanyName_Req",
    MyK_Label_ShoppingCart_FirstName_Req: "MyK_Label_ShoppingCart_FirstName_Req",
    MyK_Label_ShoppingCart_LastName_Req: "MyK_Label_ShoppingCart_LastName_Req",
    MyK_Label_ShoppingCart_Address1_Req: "MyK_Label_ShoppingCart_Address1_Req",
    MyK_Label_ShoppingCart_StreetAddress_Req: "MyK_Label_ShoppingCart_StreetAddress_Req",
    MyK_Label_ShoppingCart_City_Req: "MyK_Label_ShoppingCart_City_Req",
    MyK_Label_ShoppingCart_Country_Req: "MyK_Label_ShoppingCart_Country_Req",
    MyK_Label_ShoppingCart_State_Req: "MyK_Label_ShoppingCart_State_Req",
    MyK_Label_ShoppingCart_Zip_Req: "MyK_Label_ShoppingCart_Zip_Req",
    MyK_Label_ShoppingCart_Back_To_Cart: "MyK_Label_ShoppingCart_Back_To_Cart",
    MyK_Label_SC_Payment_Method_Req: "MyK_Label_SC_Payment_Method_Req",
    MyK_Label_SC_PoNumber_Req: "MyK_Label_SC_PoNumber_Req",
    MyK_Label_SC_Fulfilment: "MyK_Label_SC_Fulfilment",
    MyK_Label_SC_Shipping: "MyK_Label_SC_Shipping",
    MyK_Label_SC_Payment: "MyK_Label_SC_Payment",
    MyK_Label_SC_Order: "MyK_Label_SC_Order",
    MyK_Label_SC_Confirmation: "MyK_Label_SC_Confirmation",
    MyK_Label_ShoppingCart_Phone_Invalid: "MyK_Label_ShoppingCart_Phone_Invalid",
    MyK_Label_ShoppingCart_Phone_Req: "MyK_Label_ShoppingCart_Phone_Req",
    MyK_Label_DistCusLocValidation: "MyK_Label_DistCusLocValidation",
    MyK_Label_PartNumberIsNotAvailable: "MyK_Label_PartNumberIsNotAvailable",
    MyK_Label_SC_Branch_Change_Confirm: "MyK_Label_SC_Branch_Change_Confirm",
    MyK_Label_SC_Branch_Change_ConfirmInfo: "MyK_Label_SC_Branch_Change_ConfirmInfo",
    MyK_Label_SC_Confirm: "MyK_Label_SC_Confirm",
    MyK_Label_SC_AddList_To_SC_Confirm: "MyK_Label_SC_AddList_To_SC_Confirm",
    MyK_Label_SC_AddList_To_SC_Confirm_Msg: "MyK_Label_SC_AddList_To_SC_Confirm_Msg",
    MyK_Label_SC_Quote: "MyK_Label_SC_Quote",
    MyK_Label_SC_NoOfParts: "MyK_Label_SC_NoOfParts",
    MyK_Label_SC_Archive_Quotes_Confirm_Msg: "MyK_Label_SC_Archive_Quotes_Confirm_Msg",
    MyK_Label_SC_Archive_Quotes: "MyK_Label_SC_Archive_Quotes",
    MyK_Label_SC_Delete_Quotes_Confirm_Msg: "MyK_Label_SC_Delete_Quotes_Confirm_Msg",
    MyK_Label_SC_Delete_Quotes: "MyK_Label_SC_Delete_Quotes",
    MyK_Label_ShoppingCart_Promo_getAvailablePartsDetails_Error_Msg: "MyK_Label_ShoppingCart_Promo_getAvailablePartsDetails_Error_Msg",
    MyK_Label_SC_Spl_Instruction: "MyK_Label_SC_Spl_Instruction",
    MyK_Label_SC_Shipping_Info: "MyK_Label_SC_Shipping_Info",
    MyK_Label_SC_Contact: "MyK_Label_SC_Contact",
    MyK_Label_SC_Shipping_Method: "MyK_Label_SC_Shipping_Method",
    MyK_Label_SC_Est_Shipping_Cost: "MyK_Label_SC_Est_Shipping_Cost",
    MyK_Label_SC_Refresh_Loader_Step1: "MyK_Label_SC_Refresh_Loader_Step1",
    MyK_Label_SC_Refresh_Loader_Step2: "MyK_Label_SC_Refresh_Loader_Step2",
    MyK_Label_SC_Refresh_Loader_Step3: "MyK_Label_SC_Refresh_Loader_Step3",
    MyK_Label_SC_Refresh_Loader_Step4: "MyK_Label_SC_Refresh_Loader_Step4",
    MyK_Label_SC_Select_Payment_Method: "MyK_Label_SC_Select_Payment_Method",
    MyK_Label_SC_Pay_Card_On_Profile: "MyK_Label_SC_Pay_Card_On_Profile",
    MyK_Label_SC_Add_New_Credit_Card: "MyK_Label_SC_Add_New_Credit_Card",
    Myk_Label_Email_SuggestionNote: "Myk_Label_Email_SuggestionNote",
    MyK_Label_SC_Substituted: "MyK_Label_SC_Substituted",
    MyK_Label_SC_Contact_Dealer: "MyK_Label_SC_Contact_Dealer",
    MyK_Label_SC_Parts_Total: "MyK_Label_SC_Parts_Total",
    MyK_Label_SC_PromoCode_Applied: "MyK_Label_SC_PromoCode_Applied",
    MyK_Label_SC_Parts_Credit_Applied: "MyK_Label_SC_Parts_Credit_Applied",
    MyK_Label_SC_Discount_SubTotal: "MyK_Label_SC_Discount_SubTotal",
    MyK_Label_SC_CreditCard_Validation: "MyK_Label_SC_CreditCard_Validation",
    Myk_Label_UploadedFileSizeValidationMessage: "Myk_Label_UploadedFileSizeValidationMessage",
    Myk_Label_PartsUploadDeleteConfirmation: "Myk_Label_PartsUploadDeleteConfirmation",
    Myk_Label_PartsUpload: "Myk_Label_PartsUpload",
    Myk_Label_ItemsDeletedSuccessfully: "Myk_Label_ItemsDeletedSuccessfully",
    MyK_Label_SC_File_Invalid_Format: "MyK_Label_SC_File_Invalid_Format",
    MyK_Label_SC_CreditCard_Required_Validation: "MyK_Label_SC_CreditCard_Required_Validation",
    MyK_Label_SC_Open_Account: "MyK_Label_SC_Open_Account",
    MyK_Label_ShoppingCart_Pickup: "MyK_Label_ShoppingCart_Pickup",
    Myk_Label_GlobalDDWarningMessage: "Myk_Label_GlobalDDWarningMessage",
    MyK_Label_ShoppingCart_Promo_Punchout: "MyK_Label_ShoppingCart_Promo_Punchout",
    MyK_Label_ShoppingCart_Branch_Availability: "MyK_Label_ShoppingCart_Branch_Availability",
    MyK_Label_SC_Select_Distributor: "MyK_Label_SC_Select_Distributor",
    MyK_Label_SC_Select_Location: "MyK_Label_SC_Select_Location",
    MyK_Label_SC_Select_Customer: "MyK_Label_SC_Select_Customer",
    MyK_Label_Please_enter_notes: "MyK_Label_Please_enter_notes",
    MyK_Label_ShoppingCart_Branch: "MyK_Label_ShoppingCart_Branch",
    MyK_Label_SC_Contact_Dealer_Availability: "MyK_Label_SC_Contact_Dealer_Availability",
    MyK_Label_SC_Ordering_Branch: "MyK_Label_SC_Ordering_Branch",
    MyK_Label_SC_Select_Ordering_Branch: "MyK_Label_SC_Select_Ordering_Branch",
    MyK_Label_SC_Dealer_Availability_Info: "MyK_Label_SC_Dealer_Availability_Info",
    MyK_Label_See_On_Map: "MyK_Label_See_On_Map",
    MyK_Label_Branch_Location: "MyK_Label_Branch_Location",
    MyK_Label_SC_Fulfilment_Availability_Summary: "MyK_Label_SC_Fulfilment_Availability_Summary",
    MyK_Label_SC_Choose_Fulfillment: "MyK_Label_SC_Choose_Fulfillment",
    MyK_Label_SC_Make_this_my_Branch: "MyK_Label_SC_Make_this_my_Branch",
    MyK_Label_SC_Select_One: "MyK_Label_SC_Select_One",
    MyK_Label_SC_Phone: "MyK_Label_SC_Phone",
    MyK_Grid_Part_Name: "MyK_Grid_Part_Name",
    MyK_Grid_Quantity_in_stock_here: "MyK_Grid_Quantity_in_stock_here",
    MyK_Label_SC_Warning: "MyK_Label_SC_Warning",
    MyK_Label_SC_Upload_Extension_Warning: "MyK_Label_SC_Upload_Extension_Warning",
    Myk_Label_PartsBookNotFound: "Myk_Label_PartsBookNotFound",
    Myk_Label_NotFound: "Myk_Label_NotFound",
    Myk_Label_ContactAdminForMore: "Myk_Label_ContactAdminForMore",
    MyK_Label_ShoppingCart_Pickup_Info: "MyK_Label_ShoppingCart_Pickup_Info",
    MyK_Grid_Price: "MyK_Grid_Price",
    MyK_SC_Order_Confirmed: "MyK_SC_Order_Confirmed",
    MyK_SC_Order_Number: "MyK_SC_Order_Number",
    MyK_SC_Order_Confirmed_Text: "MyK_SC_Order_Confirmed_Text",
    MyK_SC_Order_Add_More_Info1: "MyK_SC_Order_Add_More_Info1",
    MyK_SC_Order_Add_More_Info2: "MyK_SC_Order_Add_More_Info2",
    MyK_SC_Order_Add_More_Info3: "MyK_SC_Order_Add_More_Info3",
    MyK_Label_ShoppingCart_SMS: "MyK_Label_ShoppingCart_SMS",
    MyK_Label_SC_Email_Duplication: "MyK_Label_SC_Email_Duplication",
    MyK_Label_SC_Email_Already_Sent: "MyK_Label_SC_Email_Already_Sent",
    MyK_Label_SC_Phone_Duplication: "MyK_Label_SC_Phone_Duplication",
    MyK_Label_SC_Phone_Already_Sent: "MyK_Label_SC_Phone_Already_Sent",
    MyK_Label_ShoppingCart_Add_Email: "MyK_Label_ShoppingCart_Add_Email",
    MyK_Label_ShoppingCart_Add_Phone: "MyK_Label_ShoppingCart_Add_Phone",
    MyK_Label_SC_Order_Send_Req_Msg: "MyK_Label_SC_Order_Send_Req_Msg",
    MyK_Label_SC_Add_Contacts_For_Future: "MyK_Label_SC_Add_Contacts_For_Future",
    MyK_Label_SC_Order_Summary: "MyK_Label_SC_Order_Summary",
    MyK_Label_SC_Order_Est_Total: "MyK_Label_SC_Order_Est_Total",
    MyK_Label_SC_Order_Est_Total_With_Shipping: "MyK_Label_SC_Order_Est_Total_With_Shipping",
    MyK_Label_Print: "MyK_Label_Print",
    MyK_Label_Send: "MyK_Label_Send",
    MyK_Label_Sent: "MyK_Label_Sent",
    MyK_Label_ShoppingCart_Place_Order: "MyK_Label_ShoppingCart_Place_Order",
    MyK_Label_SC_Notification_Success_Msg: "MyK_Label_SC_Notification_Success_Msg",
    MyK_Grid_Reccomend_Quantity: "MyK_Grid_Reccomend_Quantity",
    MyK_Label_SC_Machine_Qty: "MyK_Label_SC_Machine_Qty",
    MyK_Label_SC_Saved: "MyK_Label_SC_Saved",
    MyK_Label_SC_Order_Info: "MyK_Label_SC_Order_Info",
    MyK_Label_SC_Order_Pickup_Info: "MyK_Label_SC_Order_Pickup_Info",
    MyK_Label_SC_Order_Shipping_Info: "MyK_Label_SC_Order_Shipping_Info",
    MyK_Label_AddToCartList: "MyK_Label_AddToCartList",
    Myk_SC_OrderByDuration: "Myk_SC_OrderByDuration",
    MyK_Label_SC_RelatedTo: "MyK_Label_SC_RelatedTo",
    MyK_Label_SC_Refundable_Core_Price: "MyK_Label_SC_Refundable_Core_Price",
    MyK_Label_Machine_Status: "MyK_Label_Machine_Status",
    MyK_Label_GA_CustomerName: "MyK_Label_GA_CustomerName",
    MyK_Label_GA_AdaptiveControlPartNoDesc: "MyK_Label_GA_AdaptiveControlPartNoDesc",
    MyK_Label_GA_Argus: "MyK_Label_GA_Argus",
    MyK_Label_GA_CommissionedDate: "MyK_Label_GA_CommissionedDate",
    MyK_Label_GA_ControlSystem: "MyK_Label_GA_ControlSystem",
    MyK_Label_GA_DriveVersion: "MyK_Label_GA_DriveVersion",
    MyK_Label_GA_HawkeyePartNoDesc: "MyK_Label_GA_HawkeyePartNoDesc",
    MyK_Label_GA_MachineCountry: "MyK_Label_GA_MachineCountry",
    MyK_Label_GA_PayloadPartNoDesc: "MyK_Label_GA_PayloadPartNoDesc",
    MyK_Label_GA_PrevailHardware: "MyK_Label_GA_PrevailHardware",
    MyK_Label_GA_SoftwareVersion: "MyK_Label_GA_SoftwareVersion",
    MyK_Label_GA_TrackShieldPartNoDesc: "MyK_Label_GA_TrackShieldPartNoDesc",
    MyK_Label_GA_VibrationMonitoring: "MyK_Label_GA_VibrationMonitoring",
    MyK_Label_GA_Capacity: "MyK_Label_GA_Capacity",
    MyK_Label_GA_CompatibleMachineModel: "MyK_Label_GA_CompatibleMachineModel",
    MyK_Label_GA_GetFitment: "MyK_Label_GA_GetFitment",
    MyK_Label_GA_EngineType: "MyK_Label_GA_EngineType",
    MyK_Label_GA_LyftType: "MyK_Label_GA_LyftType",
    MyK_Label_GA_DrillAutomation: "MyK_Label_GA_DrillAutomation",
    MyK_Label_GA_MaterialNo: "MyK_Label_GA_MaterialNo",
    MyK_Label_GA_TerritoryDistributorMin: "MyK_Label_GA_TerritoryDistributorMin",
    MyK_Label_SC_DeliverTo: "MyK_Label_SC_DeliverTo",
    MyK_Label_SC_FC_OrderEstimation: "MyK_Label_SC_FC_OrderEstimation",
    MyK_Label_SC_FC_ExcludeItem: "MyK_Label_SC_FC_ExcludeItem",
    MyK_Label_SC_FC_Calculate: "MyK_Label_SC_FC_Calculate",
    MyK_Label_SC_FC_EstimatedFreight: "MyK_Label_SC_FC_EstimatedFreight",
    MyK_Label_SC_FC_InfoMessage: "MyK_Label_SC_FC_InfoMessage",
    MyK_Label_SC_FC_DeliveryToRequired: "MyK_Label_SC_FC_DeliveryToRequired",
    MyK_Label_ChartNoWarrenty: "MyK_Label_ChartNoWarrenty",
    MyK_Label_MonthlyCumulativeHrs: "MyK_Label_MonthlyCumulativeHrs",
    MyK_Label_MonthlySystemHrs: "MyK_Label_MonthlySystemHrs",
    MyK_Label_MonthlyMotionTranslation: "MyK_Label_MonthlyMotionTranslation",
    MyK_Label_Chart_Runtime: "MyK_Label_Chart_Runtime",
    MyK_Label_Chart_Propel: "MyK_Label_Chart_Propel",
    MyK_Label_Chart_Swing: "MyK_Label_Chart_Swing",
    MyK_Label_Chart_Crowd: "MyK_Label_Chart_Crowd",
    MyK_Label_Chart_Hoist: "MyK_Label_Chart_Hoist",
    MyK_Label_Chart_PropelLeft: "MyK_Label_Chart_PropelLeft",
    MyK_Label_Chart_PropelRight: "MyK_Label_Chart_PropelRight",
    MyK_Label_Chart_RuntimeHrs: "MyK_Label_Chart_RuntimeHrs",
    MyK_Label_Chart_DrillTime: "MyK_Label_Chart_DrillTime",
    MyK_Label_Chart_RelocationTime: "MyK_Label_Chart_RelocationTime",
    MyK_Label_Chart_TramTime: "MyK_Label_Chart_TramTime",
    MyK_Label_Chart_DigCycleTime: "MyK_Label_Chart_DigCycleTime",
    MyK_Label_Chart_ProdCycleTime: "MyK_Label_Chart_ProdCycleTime",
    MyK_Label_Chart_NonProdCycleTime: "MyK_Label_Chart_NonProdCycleTime",
    MyK_Label_Chart_DelayZeroAct: "MyK_Label_Chart_DelayZeroAct",
    MyK_Label_Chart_DelayLowThrottle: "MyK_Label_Chart_DelayLowThrottle",
    MyK_Label_Chart_DelayShutdown: "MyK_Label_Chart_DelayShutdown",
    MyK_Label_Chart_DelayTramming: "MyK_Label_Chart_DelayTramming",
    MyK_Label_Chart_DelayUnknown: "MyK_Label_Chart_DelayUnknown",
    MyK_Label_Chart_Grid_Runtime: "MyK_Label_Chart_Grid_Runtime",
    MyK_Label_Chart_Grid_Hoist: "MyK_Label_Chart_Grid_Hoist",
    MyK_Label_Chart_Grid_Crowd: "MyK_Label_Chart_Grid_Crowd",
    MyK_Label_Chart_Grid_Swing: "MyK_Label_Chart_Grid_Swing",
    MyK_Label_Chart_Grid_Propel: "MyK_Label_Chart_Grid_Propel",
    MyK_Label_Chart_Grid_MonthYear: "MyK_Label_Chart_Grid_MonthYear",
    MyK_Label_Chart_Grid_DayMonthYear: "MyK_Label_Chart_Grid_DayMonthYear",
    MyK_Label_Chart_Grid_PropelLeft: "MyK_Label_Chart_Grid_PropelLeft",
    MyK_Label_Chart_Grid_PropelRight: "MyK_Label_Chart_Grid_PropelRight",
    MyK_Label_Chart_Grid_RuntimeHrs: "MyK_Label_Chart_Grid_RuntimeHrs",
    MyK_Label_Chart_Grid_DrillTime: "MyK_Label_Chart_Grid_DrillTime",
    MyK_Label_Chart_Grid_RelocationTime: "MyK_Label_Chart_Grid_RelocationTime",
    MyK_Label_Chart_Grid_TramTime: "MyK_Label_Chart_Grid_TramTime",
    MyK_Label_Chart_Grid_DigCycleTime: "MyK_Label_Chart_Grid_DigCycleTime",
    MyK_Label_Chart_Grid_ProdCycleTime: "MyK_Label_Chart_Grid_ProdCycleTime",
    MyK_Label_Chart_Grid_NonProdCycleTime: "MyK_Label_Chart_Grid_NonProdCycleTime",
    MyK_Label_Chart_Grid_DelayZeroAct: "MyK_Label_Chart_Grid_DelayZeroAct",
    MyK_Label_Chart_Grid_DelayLowThrottle: "MyK_Label_Chart_Grid_DelayLowThrottle",
    MyK_Label_Chart_Grid_DelayShutdown: "MyK_Label_Chart_Grid_DelayShutdown",
    MyK_Label_Chart_Grid_DelayTramming: "MyK_Label_Chart_Grid_DelayTramming",
    MyK_Label_Chart_Grid_DelayUnknown: "MyK_Label_Chart_Grid_DelayUnknown",
    MyK_MyCoverage_Terms_Month: 'MyK_MyCoverage_Terms_Month',
    MyK_Label_PSNNo: "MyK_Label_PSNNo",
    MyK_Label_Export: "MyK_Label_Export",
    MyK_Label_Partsbook: "MyK_Label_Partsbook",
    MyK_Label_SpecSheets: "MyK_Label_SpecSheets",
    MyK_Label_OpenPartsBook: "MyK_Label_OpenPartsBook",
    MyK_Label_ViewInfo: "MyK_Label_ViewInfo",
    MyK_Label_SC_Puchout_History: "MyK_Label_SC_Puchout_History",
    MyK_Label_SC_Puchout_Date: "MyK_Label_SC_Puchout_Date",
    MyK_Label_SC_Puchout: "MyK_Label_SC_Puchout",
    MyK_Label_SC_Puchout_DistributorName: "MyK_Label_SC_Puchout_DistributorName",
    MyK_Label_SC_Puchout_CustomerName: "MyK_Label_SC_Puchout_CustomerName",
    MyK_Label_SC_Puchout_By: "MyK_Label_SC_Puchout_By",
    MyK_Label_SC_Puchout_Of_Items : "MyK_Label_SC_Puchout_Of_Items",
    MyK_Label_SC_Note: "MyK_Label_SC_Note",
    MyK_Label_SC_NoteInformation:"MyK_Label_SC_NoteInformation",
    MyK_Label_DocumentNo: "MyK_Label_DocumentNo",
    MyK_MyCoverage_Months: "MyK_MyCoverage_Months",
    MyK_Label_OperatorandMaintenanceManual: "MyK_Label_OperatorandMaintenanceManual",
    MyK_Label_Fault_Tooltip_0: "MyK_Label_Fault_Tooltip_0",
    MyK_Label_Fault_Tooltip_23:"MyK_Label_Fault_Tooltip_23",
    MyK_Label_Warning_Tooltip_1: "MyK_Label_Warning_Tooltip_1",
    MyK_Label_Warning_Tooltip_4: "MyK_Label_Warning_Tooltip_4",
    MyK_Label_Overdue_Tooltip: "MyK_Label_Overdue_Tooltip",
    MyK_Label_Upcoming_Tooltip: "MyK_Label_Upcoming_Tooltip",
    MyK_Label_HoleCount: "MyK_Label_HoleCount",
    MyK_Label_TotalHoleDepth: "MyK_Label_TotalHoleDepth",
    MyK_Label_ProductiveROP: "MyK_Label_ProductiveROP",
    MyK_Label_InstantaneousROP: "MyK_Label_InstantaneousROP",
    MyK_Label_DipperTripCount: "MyK_Label_DipperTripCount",
    MyK_Label_CycleCount: "MyK_Label_CycleCount",
    MyK_Label_PayloadTons: "MyK_Label_PayloadTons",
    MyK_Label_CycleTime: "MyK_Label_CycleTime",
    MyK_Label_AvgCycleTime: "MyK_Label_AvgCycleTime",
    MyK_Label_ProductiveCycleCount: "MyK_Label_ProductiveCycleCount",
    MyK_Label_NonProductiveCycleCount: "MyK_Label_NonProductiveCycleCount",
    MyK_Label_ProductiveCyclePayload: "MyK_Label_ProductiveCyclePayload",
    MyK_Label_NonProductiveCyclePayload: "MyK_Label_NonProductiveCyclePayload",
    MyK_Label_CycleDistance: "MyK_Label_CycleDistance",
    MyK_Label_ProductiveFuel: "MyK_Label_ProductiveFuel",
    MyK_Label_NonProductiveFuel: "MyK_Label_NonProductiveFuel",
    MyK_Label_MachineRunHours: "MyK_Label_MachineRunHours",
    MyK_Label_TruckCount: "MyK_Label_TruckCount",
    MyK_Label_CyclePayload: "MyK_Label_CyclePayload",
    MyK_Label_FuelMetrics: "MyK_Label_FuelMetrics",
    MyK_Label_ReportType: "MyK_Label_ReportType",
    Myk_Label_Unit_of_Measure: "Myk_Label_Unit_of_Measure",
    Myk_Label_Report_DailyView_Message: "Myk_Label_Report_DailyView_Message",
    Myk_Label_Report_WeeklyView_Message: "Myk_Label_Report_WeeklyView_Message",
    Myk_Label_Report_MonthlyView_Message: "Myk_Label_Report_MonthlyView_Message",
    MyK_Label_Productive: "MyK_Label_Productive",
    MyK_Label_NonProductive: "MyK_Label_NonProductive",
    MyK_Label_ComponentTracking: "MyK_Label_ComponentTracking",
    MyK_Label_Outage_start_time:"MyK_Label_Outage_start_time",
    MyK_Label_Minutes: "MyK_Label_Minutes",
    MyK_Label_Occurence: "MyK_Label_Occurence",
    MyK_Label_Hours_SMR: "MyK_Label_Hours_SMR",
    MyK_Label_Date: "MyK_Label_Date",
    MyK_Label_Time: "MyK_Label_Time",
    MyK_Label_Occurrences: "MyK_Label_Occurrences",
    MyK_Label_Subsystem: "MyK_Label_Subsystem",
    MyK_Label_Event_description: "MyK_Label_Event_description",
    MyK_Label_Event_code: "MyK_Label_Event_code",
    MyK_Label_Description_Grid: "MyK_Label_Description_Grid",
    MyK_Label_TotalDowntime: "MyK_Label_TotalDowntime",
    MyK_Label_Mode: "MyK_Label_Mode",
    MyK_Label_Subsytem: "MyK_Label_Subsytem",
    MyK_Label_ActionLevel: "MyK_Label_ActionLevel",
    MyK_Label_DateOrTime: "MyK_Label_DateOrTime",
    MyK_Label_Event_Codes: "MyK_Label_Event_Codes",
    MyK_Label_LifeUsed: "MyK_Label_LifeUsed",
    MyK_Label_Installed_partnumber: "MyK_Label_Installed_partnumber",
    MyK_Label_Part_replacement_strategy: "MyK_Label_Part_replacement_strategy",
    MyK_Label_Changeout_date: "MyK_Label_Changeout_date",
    MyK_Label_Current_component_hours : "MyK_Label_Current_component_hours",
    MyK_Label_Local_target_hours: "MyK_Label_Local_target_hours",
    MyK_Label_Replacement_partnumber: "MyK_Label_Replacement_partnumber",
    MyK_Label_Component: "MyK_Label_Component",
    MyK_Label_HoleCount_Monthly: "MyK_Label_HoleCount_Monthly",
    MyK_Label_TotalHoleDepth_Monthly: "MyK_Label_TotalHoleDepth_Monthly",
    MyK_Label_ProductiveROP_Monthly: "MyK_Label_ProductiveROP_Monthly",
    MyK_Label_InstantaneousROP_Monthly: "MyK_Label_InstantaneousROP_Monthly",
    MyK_Label_DipperTripCount_Monthly: "MyK_Label_DipperTripCount_Monthly",
    MyK_Label_CycleCount_Monthly: "MyK_Label_CycleCount_Monthly",
    MyK_Label_PayloadTons_Monthly: "MyK_Label_PayloadTons_Monthly",
    MyK_Label_CycleTime_Monthly: "MyK_Label_CycleTime_Monthly",
    MyK_Label_ProductiveCycleCount_Monthly: "MyK_Label_ProductiveCycleCount_Monthly",
    MyK_Label_NonProductiveCycleCount_Monthly: "MyK_Label_NonProductiveCycleCount_Monthly",
    MyK_Label_ProductiveCyclePayload_Monthly: "MyK_Label_ProductiveCyclePayload_Monthly",
    MyK_Label_NonProductiveCyclePayload_Monthly: "MyK_Label_NonProductiveCyclePayload_Monthly",
    MyK_Label_CycleDistance_Monthly: "MyK_Label_CycleDistance_Monthly",
    MyK_Label_ProductiveFuel_Monthly: "MyK_Label_ProductiveFuel_Monthly",
    MyK_Label_NonProductiveFuel_Monthly: "MyK_Label_NonProductiveFuel_Monthly",
    MyK_Label_MachineRunHours_Monthly: "MyK_Label_MachineRunHours_Monthly",
    MyK_Label_TruckCount_Monthly: "MyK_Label_TruckCount_Monthly",
    MyK_Label_FuelMetrics_Monthly: "MyK_Label_FuelMetrics_Monthly",
    MyK_Label_HoleCount_Daily: "MyK_Label_HoleCount_Daily",
    MyK_Label_TotalHoleDepth_Daily: "MyK_Label_TotalHoleDepth_Daily",
    MyK_Label_ProductiveROP_Daily: "MyK_Label_ProductiveROP_Daily",
    MyK_Label_InstantaneousROP_Daily: "MyK_Label_InstantaneousROP_Daily",
    MyK_Label_DipperTripCount_Daily: "MyK_Label_DipperTripCount_Daily",
    MyK_Label_CycleCount_Daily: "MyK_Label_CycleCount_Daily",
    MyK_Label_PayloadTons_Daily: "MyK_Label_PayloadTons_Daily",
    MyK_Label_CycleTime_Daily: "MyK_Label_CycleTime_Daily",
    MyK_Label_ProductiveCycleCount_Daily: "MyK_Label_ProductiveCycleCount_Daily",
    MyK_Label_NonProductiveCycleCount_Daily: "MyK_Label_NonProductiveCycleCount_Daily",
    MyK_Label_ProductiveCyclePayload_Daily: "MyK_Label_ProductiveCyclePayload_Daily",
    MyK_Label_NonProductiveCyclePayload_Daily: "MyK_Label_NonProductiveCyclePayload_Daily",
    MyK_Label_CycleDistance_Daily: "MyK_Label_CycleDistance_Daily",
    MyK_Label_ProductiveFuel_Daily: "MyK_Label_ProductiveFuel_Daily",
    MyK_Label_NonProductiveFuel_Daily: "MyK_Label_NonProductiveFuel_Daily",
    MyK_Label_MachineRunHours_Daily: "MyK_Label_MachineRunHours_Daily",
    MyK_Label_TruckCount_Daily: "MyK_Label_TruckCount_Daily",
    MyK_UnitMeasurementMeter: "MyK_UnitMeasurementMeter",
    MyK_UnitMeasurementMpH: "MyK_UnitMeasurementMpH",
    MyK_UnitMeasurementFeet: "MyK_UnitMeasurementFeet",
    MyK_UnitMeasurementGalperHour: "MyK_UnitMeasurementGalperHour",
    MyK_UnitMeasurementSeconds: "MyK_UnitMeasurementSeconds",
    MyK_Label_TotalTrucks: "MyK_Label_TotalTrucks",
    MyK_UnitMeasurementGallonsPerHour: "MyK_UnitMeasurementGallonsPerHour",
    MyK_UnitMeasurementFullFeet: "MyK_UnitMeasurementFullFeet",
    MyK_Label_TotalPayload: "MyK_Label_TotalPayload",
    MyK_UnitMeasurementMeters: "MyK_UnitMeasurementMeters",
    MyK_UnitMeasurementMetersPerHour: "MyK_UnitMeasurementMetersPerHour",
    MyK_Label_AbnormalitySearchPlaceholder: "MyK_Label_AbnormalitySearchPlaceholder",
    MyK_Label_DailyCumulativeHrs: "MyK_Label_DailyCumulativeHrs",
    MyK_Label_DailySystemHrs: "MyK_Label_DailySystemHrs",
    MyK_Label_DailyMotionTranslation: "MyK_Label_DailyMotionTranslation",
    MyK_Label_MeanRotarySpeed: "MyK_Label_MeanRotarySpeed",
    MyK_Label_Meanpulldown: "MyK_Label_Meanpulldown",
    MyK_Label_MeanPressureTranslation: "MyK_Label_MeanPressureTranslation",
    MyK_Label_Pressure: "MyK_Label_Pressure",
    MyK_Label_Speed: "MyK_Label_Speed",
    MyK_Label_Pulldown: "MyK_Label_Pulldown",
    MyK_Title_FC_DistributorView_Mining: "MyK_Title_FC_DistributorView_Mining",
    MyK_Title_FC_CustomerView_Mining: "MyK_Title_FC_CustomerView_Mining",
    MyK_FCGrid_PSNNumberMin: "MyK_FCGrid_PSNNumberMin",
    MyK_Label_DocumentSubType: "MyK_Label_DocumentSubType",
    MyK_FCGrid_MaxSMRHours: "MyK_FCGrid_MaxSMRHours",
    MyK_utilization_Hours: "MyK_utilization_Hours",
    MyK_Label_Monthly_SSText: "MyK_Label_Monthly_SSText",
    MyK_Label_Weekly_SSText: "MyK_Label_Weekly_SSText",
    MyK_Label_Daily_SSText: "MyK_Label_Daily_SSText",
    MyK_utilization_Meters: "MyK_utilization_Meters",
    MyK_utilization_meters_unit: "MyK_utilization_meters_unit",
    MyK_Label_Chart_Grid_Hoist_Meter: "MyK_Label_Chart_Grid_Hoist_Meter",
    MyK_Label_Chart_Grid_Crowd_Meter: "MyK_Label_Chart_Grid_Crowd_Meter",
    MyK_Label_Chart_Grid_PropelLeft_Meter: "MyK_Label_Chart_Grid_PropelLeft_Meter",
    MyK_Label_Chart_Grid_PropelRight_Meter: "MyK_Label_Chart_Grid_PropelRight_Meter",
    MyK_Documents_Serialnumber: "MyK_Documents_Serialnumber",
    MyK_FleetLabel_ShowingResultText_Mining: "MyK_FleetLabel_ShowingResultText_Mining",
    MyK_FleetLabel_ListView_SMRHrs: "MyK_FleetLabel_ListView_SMRHrs",
    MyK_FleetLabel_ListView_PayloadTonnes: "MyK_FleetLabel_ListView_PayloadTonnes",
    MyK_FleetLabel_ListView_HoleCount: "MyK_FleetLabel_ListView_HoleCount",
    MyK_FleetLabel_ListView_ProductiveTons: "MyK_FleetLabel_ListView_ProductiveTons",
    MyK_FleetLabel_QuickStat_ComponentTracking: "MyK_FleetLabel_QuickStat_ComponentTracking",
    MyK_FleetLabel_QuickStat_ComponentTracking_Tooltip: "MyK_FleetLabel_QuickStat_ComponentTracking_Tooltip",
    MyK_ShareReport_PopupTitle: "MyK_ShareReport_PopupTitle",
    MyK_ShareReport_SendTo: "MyK_ShareReport_SendTo",
    MyK_ShareReport_PlaceHolder: "MyK_ShareReport_PlaceHolder",
    MyK_ShareReport_Email_RequiredMessage: "MyK_ShareReport_Email_RequiredMessage",
    MyK_ShareReport_Email_ValidationFailedMessage: "MyK_ShareReport_Email_ValidationFailedMessage",
    MyK_ShareReport_Email_SuccessMessage: "MyK_ShareReport_Email_SuccessMessage",
    MyK_ShareReport_Email_FailureMessage: "MyK_ShareReport_Email_FailureMessage",
    MyK_AppNotificationLabel_ClickSerialNumberToViewGSNGSA: "MyK_AppNotificationLabel_ClickSerialNumberToViewGSNGSA",
    Myk_Label_OrderHistory_MyKomatsuRef: "Myk_Label_OrderHistory_MyKomatsuRef",
    Myk_Label_OrderHistory_OrderDate: "Myk_Label_OrderHistory_OrderDate",
    Myk_Label_OrderHistory_PONumber: "Myk_Label_OrderHistory_PONumber",
    Myk_Label_OrderHistory_ofOrders: "Myk_Label_OrderHistory_ofOrders",
    Myk_Label_OrderHistory_ItemCount: "Myk_Label_OrderHistory_ItemCount",
    Myk_Label_OrderHistory_PartsTotal: "Myk_Label_OrderHistory_PartsTotal",
    Myk_Label_OrderHistory_Order: "Myk_Label_OrderHistory_Order",
    Myk_Label_OrderHistory_Fulfillment: "Myk_Label_OrderHistory_Fulfillment",
    Myk_Label_OrderHistory_DistributorName: "Myk_Label_OrderHistory_DistributorName",
    Myk_Label_OrderHistory_CustomerName: "Myk_Label_OrderHistory_CustomerName",
    Myk_Label_OrderHistory_OrderedBy: "Myk_Label_OrderHistory_OrderedBy",
    Myk_Label_OrderHistory_PaymentType: "Myk_Label_OrderHistory_PaymentType",
    Myk_Label_OrderHistory_PaymentStatus: "Myk_Label_OrderHistory_PaymentStatus",
    Myk_Label_OrderHistory_OrderStatus: "Myk_Label_OrderHistory_OrderStatus",
    Myk_Label_OrderHistory_Part: "Myk_Label_OrderHistory_Part",
    Myk_Label_OrderHistory_Description: "Myk_Label_OrderHistory_Description",
    Myk_Label_OrderHistory_Machine: "Myk_Label_OrderHistory_Machine",
    Myk_Label_OrderHistory_Manufacturer: "Myk_Label_OrderHistory_Manufacturer",
    Myk_Label_OrderHistory_Status: "Myk_Label_OrderHistory_Status",
    Myk_Label_OrderHistory_Returnable: "Myk_Label_OrderHistory_Returnable",
    Myk_Label_OrderHistory_Qty: "Myk_Label_OrderHistory_Qty",
    Myk_Label_OrderHistory_UnitPrice: "Myk_Label_OrderHistory_UnitPrice",
    Myk_Label_OrderHistory_ExtendedPrice: "Myk_Label_OrderHistory_ExtendedPrice",
    Myk_Label_OrderHistory_Shipment: "Myk_Label_OrderHistory_Shipment",
    Myk_Label_OrderHistory_Carrier: "Myk_Label_OrderHistory_Carrier",
    Myk_Label_OrderHistory_Tracking: "Myk_Label_OrderHistory_Tracking",
    Myk_Label_OrderHistory_ofitems: "Myk_Label_OrderHistory_ofitems",
    Myk_Label_OrderHistory_of: "Myk_Label_OrderHistory_of",
    Myk_Label_OrderHistory_MyKomatsuReferenceID: "Myk_Label_OrderHistory_MyKomatsuReferenceID",
    Myk_Label_OrderHistory_Orderedon: "Myk_Label_OrderHistory_Orderedon",
    Myk_Label_OrderHistory_OrderNumber: "Myk_Label_OrderHistory_OrderNumber",
    Myk_Label_OrderHistory_TrackingNumber: "Myk_Label_OrderHistory_TrackingNumber",
    Myk_Label_OrderHistory_Notes: "Myk_Label_OrderHistory_Notes",
    Myk_Label_OrderHistory_ShipmentLocation: "Myk_Label_OrderHistory_ShipmentLocation",
    Myk_Label_OrderHistory_FlexibleField: "Myk_Label_OrderHistory_FlexibleField",
    Myk_Label_OrderHistory_SpecialInstructions: "Myk_Label_OrderHistory_SpecialInstructions",
    Myk_Label_OrderHistory_PaymentMethod: "Myk_Label_OrderHistory_PaymentMethod",
    Myk_Label_OrderHistory_DeliveryAddress: "Myk_Label_OrderHistory_DeliveryAddress",
    Myk_Label_OrderHistory_PickupAddress: "Myk_Label_OrderHistory_PickupAddress",
    Myk_Label_OrderHistory_DeliveryEmail: "Myk_Label_OrderHistory_DeliveryEmail",
    Myk_Label_OrderHistory_Email: "Myk_Label_OrderHistory_Email",
    Myk_Label_OrderHistory_OrderHistory: "Myk_Label_OrderHistory_OrderHistory",
    Myk_Label_OrderHistory_OrderTracking: "Myk_Label_OrderHistory_OrderTracking",
    Myk_Label_OrderHistory_OrderTrackingSearch: "Myk_Label_OrderHistory_OrderTrackingSearch",
    Myk_Label_OrderHistory_IsReadyForPickup: "Myk_Label_OrderHistory_IsReadyForPickup",
    Myk_Label_OrderHistory_ViewPickupLocation: "Myk_Label_OrderHistory_ViewPickupLocation",
    Myk_Label_OrderHistory_ViewOrderTracking: "Myk_Label_OrderHistory_ViewOrderTracking",
    Myk_Label_OrderHistory_ViewOrderHistory:"Myk_Label_OrderHistory_ViewOrderHistory",
    Myk_Label_OrderHistory_PO: "Myk_Label_OrderHistory_PO",
    Myk_Label_OrderHistory_SearchByOrder: "Myk_Label_OrderHistory_SearchByOrder",
    Myk_Label_OrderHistory_MyKRef: "Myk_Label_OrderHistory_MyKRef",
    Myk_Label_OrderHistory_ViewRewards: "Myk_Label_OrderHistory_ViewRewards",
    Myk_Label_OrderHistory_FulfillmentType: "Myk_Label_OrderHistory_FulfillmentType",
    Myk_Label_OrderHistory_PartNumber: "Myk_Label_OrderHistory_PartNumber",
    MyK_Label_SC_Your_Ordering_Branch: "MyK_Label_SC_Your_Ordering_Branch",
    MyK_Label_SC_Fulfilment_Availability_Summary_Info: "MyK_Label_SC_Fulfilment_Availability_Summary_Info",
    MyK_Label_SC_Availability_Summary: "MyK_Label_SC_Availability_Summary",
    Myk_Info_SC_FAS_Header: "Myk_Info_SC_FAS_Header",
    Myk_Info_SC_FAS_HeaderDetailTitle: "Myk_Info_SC_FAS_HeaderDetailTitle",
    Myk_Info_SC_FAS_HeaderDetailDescription: "Myk_Info_SC_FAS_HeaderDetailDescription",
    Myk_Info_SC_FAS_OrderingBranch_Info: "Myk_Info_SC_FAS_OrderingBranch_Info",
    Myk_Info_SC_FAS_OrderingBranch_Info_Pickup: "Myk_Info_SC_FAS_OrderingBranch_Info_Pickup",
    Myk_Info_SC_FulFill_Remainder: "Myk_Info_SC_FulFill_Remainder",
    MyK_Label_ShoppingCart_Shipment: "MyK_Label_ShoppingCart_Shipment",
    MyK_Label_ShoppingCart_Pickup_WillCall: "MyK_Label_ShoppingCart_Pickup_WillCall",
    MyK_Label_ShoppingCart_Pickup_WillCall_Info: "MyK_Label_ShoppingCart_Pickup_WillCall_Info",
    MyK_Label_ShoppingCart_Pickup_AvailablePlus: "MyK_Label_ShoppingCart_Pickup_AvailablePlus",
    MyK_Label_ShoppingCart_Pickup_AvailablePlus_Info: "MyK_Label_ShoppingCart_Pickup_AvailablePlus_Info",
    MyK_Label_ShoppingCart_ShippingOption_Info: "MyK_Label_ShoppingCart_ShippingOption_Info",
    Myk_Info_SC_Select_Shipping: "Myk_Info_SC_Select_Shipping",
    MyK_Label_ShoppingCart_FC_NameFirstLast: "MyK_Label_ShoppingCart_FC_NameFirstLast",
    MyK_Label_ShoppingCart_FC_Optional: "MyK_Label_ShoppingCart_FC_Optional",
    MyK_Label_ShoppingCart_FC_EnterName: "MyK_Label_ShoppingCart_FC_EnterName",
    MyK_Label_ShoppingCart_FC_Attention: "MyK_Label_ShoppingCart_FC_Attention",
    MyK_Label_ShoppingCart_FC_Name: "MyK_Label_ShoppingCart_FC_Name",
    MyK_Label_ShoppingCart_FC_Attention_Req: "MyK_Label_ShoppingCart_FC_Attention_Req",
    MyK_Label_ShoppingCart_FC_PhoneCode_Req:"MyK_Label_ShoppingCart_FC_PhoneCode_Req",
    Myk_Label_OrderHistory_GrandTotal: "Myk_Label_OrderHistory_GrandTotal",
    Myk_Label_OrderHistory_RequestedShippingType: "Myk_Label_OrderHistory_RequestedShippingType",
    Myk_Label_OrderHistory_ItemsSubTotal: "Myk_Label_OrderHistory_ItemsSubTotal",
    Myk_Label_OrderHistory_Charges: "Myk_Label_OrderHistory_Charges",
    Myk_Label_OrderHistory_AmountPaid: "Myk_Label_OrderHistory_AmountPaid",
    Myk_Label_OrderHistory_ShippingAddress: "Myk_Label_OrderHistory_ShippingAddress",
    Myk_Label_OrderHistory_CustomerComments: "Myk_Label_OrderHistory_CustomerComments",
    Myk_Label_OrderHistory_OriginalOrders: "Myk_Label_OrderHistory_OriginalOrders",
    Myk_Label_OrderHistory_QtyOrdered: "Myk_Label_OrderHistory_QtyOrdered",
    Myk_Label_OrderHistory_TotalPrice: "Myk_Label_OrderHistory_TotalPrice",
    Myk_Label_OrderHistory_AllOrders: "Myk_Label_OrderHistory_AllOrders",
    Myk_Label_OrderHistory_CompletedOrders: "Myk_Label_OrderHistory_CompletedOrders",
    Myk_Label_OrderHistory_PendingOrders: "Myk_Label_OrderHistory_PendingOrders",
    MyK_Label_ShoppingCart_Pickup_AvailablePlus_ShippingInfo: "MyK_Label_ShoppingCart_Pickup_AvailablePlus_ShippingInfo",
    MyK_Label_SC_You_Selected: "MyK_Label_SC_You_Selected",
    MyK_Label_SC_Fullfilment_Total: "MyK_Label_SC_Fullfilment_Total",
    MyK_Label_SC_Est_Shipping_Total: "MyK_Label_SC_Est_Shipping_Total",
    MyK_Label_SC_OrderSummary_By_FullfilmentType: "MyK_Label_SC_OrderSummary_By_FullfilmentType",
    MyK_Label_SC_Order_Information: "MyK_Label_SC_Order_Information",
    MyK_Label_ShoppingCart_State_Territory: "MyK_Label_ShoppingCart_State_Territory",
    Myk_Label_OrderHistory_ShowGuestOrdersOnly: "Myk_Label_OrderHistory_ShowGuestOrdersOnly",
    MyK_Label_Filter: "MyK_Label_Filter",
    Myk_Label_OrderHistory_Placed: "Myk_Label_OrderHistory_Placed",
    Myk_Label_OrderHistory_Readyforpickup: "Myk_Label_OrderHistory_Readyforpickup",
    Myk_Label_OrderHistory_Shipped: "Myk_Label_OrderHistory_Shipped",
    Myk_Label_OrderHistory_Delayed: "Myk_Label_OrderHistory_Delayed",
    Myk_Label_OrderHistory_PickedUp: "Myk_Label_OrderHistory_PickedUp",
    Myk_Label_OrderHistory_Delivered: "Myk_Label_OrderHistory_Delivered",
    MyK_Label_OperationStatus_Date: "MyK_Label_OperationStatus_Date",
    MyK_Label_OperationStatus_Smr: "MyK_Label_OperationStatus_Smr",
    MyK_Label_OperationStatus_TotalPayload: "MyK_Label_OperationStatus_TotalPayload",
    MyK_Label_OperationStatus_AvgCycleDuration: "MyK_Label_OperationStatus_AvgCycleDuration",
    MyK_Label_OperationStatus_CycleCount: "MyK_Label_OperationStatus_CycleCount",
    MyK_Label_OperationStatus_SystemPropelHours: "MyK_Label_OperationStatus_SystemPropelHours",
    MyK_Label_OperationStatus_OperatingHours: "MyK_Label_OperationStatus_OperatingHours",
    MyK_Label_OperationStatus_ProductiveTons: "MyK_Label_OperationStatus_ProductiveTons",
    MyK_Label_OperationStatus_PeriodFuelBurn: "MyK_Label_OperationStatus_PeriodFuelBurn",
    MyK_Label_OperationStatus_BucketPayload: "MyK_Label_OperationStatus_BucketPayload",
    MyK_Label_OperationStatus_HoleCount: "MyK_Label_OperationStatus_HoleCount",
    MyK_Label_OperationStatus_AvgHoleDepth: "MyK_Label_OperationStatus_AvgHoleDepth",
    MyK_Label_OperationStatus_DrillTime: "MyK_Label_OperationStatus_DrillTime",
    MyK_Label_OperationStatus_AutoDrillTime: "MyK_Label_OperationStatus_AutoDrillTime",
    MyK_Label_OperationStatus_ViewHistory: "MyK_Label_OperationStatus_ViewHistory",
    MyK_Label_OperationStatus_OperationStatusDate: "MyK_Label_OperationStatus_OperationStatusDate",
    MyK_Label_SC_Select_Carrier: "MyK_Label_SC_Select_Carrier",
    MyK_Label_SC_Carrier_Selection_Warning: "MyK_Label_SC_Carrier_Selection_Warning",
    Myk_Label_SC_ShareQuotes_Dropfile: "Myk_Label_SC_ShareQuotes_Dropfile",
    MyK_Label_SC_Up_Done: "MyK_Label_SC_Up_Done",
    MyK_Label_SC_Up_Uploading: "MyK_Label_SC_Up_Uploading",
    MyK_Label_SC_Up_Retry: "MyK_Label_SC_Up_Retry",
    MyK_Label_SC_Up_Total: "MyK_Label_SC_Up_Total",
    MyK_Label_SC_Up_Upload_File: "MyK_Label_SC_Up_Upload_File",
    MyK_Label_OrderHistory_OrderDetails: "MyK_Label_OrderHistory_OrderDetails",
    MyK_Label_OrderHistory_Quotes: "MyK_Label_OrderHistory_Quotes",
    MyK_Label_OrderHistory_AddParts: "MyK_Label_OrderHistory_AddParts",
    MyK_Label_OrderHistory_OrderPlacedBy: "MyK_Label_OrderHistory_OrderPlacedBy",
    MyK_Label_SC_Fulfillment_Additional_Pickup_WillCall: "MyK_Label_SC_Fulfillment_Additional_Pickup_WillCall",
    MyK_Label_OrderHistory_YourOrderHasBeenPlaced:"MyK_Label_OrderHistory_YourOrderHasBeenPlaced",
    MyK_Label_SC_File_Invalid_PartNumber: "MyK_Label_SC_File_Invalid_PartNumber",
    MyK_Label_ShoppingCart_Shipping_Carrier_Failed: "MyK_Label_ShoppingCart_Shipping_Carrier_Failed",
    MyK_Label_OrderHistory_YourOrderHasBeenShipped: "MyK_Label_OrderHistory_YourOrderHasBeenShipped",
    MyK_Label_OrderHistory_YourOrderHasBeenDelivered: "MyK_Label_OrderHistory_YourOrderHasBeenDelivered",
    MyK_Label_OrderHistory_YourOrderHasBeenDelayed: "MyK_Label_OrderHistory_YourOrderHasBeenDelayed",
    MyK_Label_OrderHistory_YourOrderIsReadyForPickup: "MyK_Label_OrderHistory_YourOrderIsReadyForPickup",
    MyK_Label_OrderHistory_YourOrderHasBeenPickedup: "MyK_Label_OrderHistory_YourOrderHasBeenPickedup",
    MyK_Label_SC_PartCreditRemoved_Confirmation: "MyK_Label_SC_PartCreditRemoved_Confirmation",
    MyK_Please_Select: "MyK_Please_Select",
    Myk_Label_SC_Credit_Card_Disabled_Error: "Myk_Label_SC_Credit_Card_Disabled_Error",
    Myk_Label_SC_OT_Search_NotFound: "Myk_Label_SC_OT_Search_NotFound",
    MyK_FCGrid_PSNNotFound: "MyK_FCGrid_PSNNotFound",
    MyK_Label_SMining_Distributor_Message: "MyK_Label_SMining_Distributor_Message",
    Myk_Label_Phone_Number: "Myk_Label_Phone_Number",
    MyK_Label_MiningPartsList_ErrorMessage: "MyK_Label_MiningPartsList_ErrorMessage",
    Myk_Label_Mining_PartsLists: "Myk_Label_Mining_PartsLists",
    Myk_Label_PMMachine_ID: "Myk_Label_PMMachine_ID",
    Myk_Label_TrendsSN: "Myk_Label_TrendsSN",
    Myk_Label_TrendItemCode: "Myk_Label_TrendItemCode",
    Myk_Label_MinValue: "Myk_Label_MinValue",
    Myk_Label_MaxValue: "Myk_Label_MaxValue",
    Myk_Label_AvgValue: "Myk_Label_AvgValue",
    Myk_Label_DimensionName: "Myk_Label_DimensionName",
    Myk_Label_HelpText: "Myk_Label_HelpText",
    Myk_Label_TrendSMR: "Myk_Label_TrendSMR",
    Myk_Label_TrendDate: "Myk_Label_TrendDate",
    Myk_Label_SC_Credit_Card_Disabled_CreditLimit_Msg: "Myk_Label_SC_Credit_Card_Disabled_CreditLimit_Msg",
    Myk_Label_SC_Credit_Card_Enabled_CreditLimit_Msg: "Myk_Label_SC_Credit_Card_Enabled_CreditLimit_Msg",
    Myk_Label_Error_Distributor_Selection: "Myk_Label_Error_Distributor_Selection",
    Myk_Label_Message: "Myk_Label_Message",
    Myk_Label_ShowHideColumn: "Myk_Label_ShowHideColumn",
    MyK_Label_Reset: "MyK_Label_Reset",
    MyK_Label_TableCustomization: "MyK_Label_TableCustomization",
    Myk_Label_SC_ShareEmail_Line1: "Myk_Label_SC_ShareEmail_Line1",
    Myk_Label_SC_ShareEmail_Line2: "Myk_Label_SC_ShareEmail_Line2",
    Myk_Label_SC_ShareEmail_Line2_Link: "Myk_Label_SC_ShareEmail_Line2_Link",
    Myk_Label_SC_ShareEmail_Line2_Download: "Myk_Label_SC_ShareEmail_Line2_Download",
    Myk_Label_SC_ShareEmail_Line3: "Myk_Label_SC_ShareEmail_Line3",
    Myk_Label_SC_ShareEmail_Line4: "Myk_Label_SC_ShareEmail_Line4",
    Myk_Label_SC_ShareEmail_Line5: "Myk_Label_SC_ShareEmail_Line5",
    Myk_Label_SC_ShareEmail_MykRef: "Myk_Label_SC_ShareEmail_MykRef",
    Myk_Label_SC_ShareEmail_PurchaseOrder: "Myk_Label_SC_ShareEmail_PurchaseOrder",
    MyK_Label_ShoppingCart_Availability_info: "MyK_Label_ShoppingCart_Availability_info",
    Myk_Label_SC_Shipping_Option_Warning: "Myk_Label_SC_Shipping_Option_Warning",
    MyK_Label_SC_Komatsu_Credit_History: "MyK_Label_SC_Komatsu_Credit_History",
    MyK_Label_SC_KCH_Account: "MyK_Label_SC_KCH_Account",
    MyK_Label_SC_KCH_TotalCredit : "MyK_Label_SC_KCH_TotalCredit",
    MyK_Label_SC_KCH_RemainingBalance : "MyK_Label_SC_KCH_RemainingBalance",
    MyK_Label_SC_KCH_CreditName : "MyK_Label_SC_KCH_CreditName",
    MyK_Label_SC_KCH_CreditUsage : "MyK_Label_SC_KCH_CreditUsage",
    MyK_Label_SC_KCH_PurchaseDate : "MyK_Label_SC_KCH_PurchaseDate",
    MyK_Label_SC_KCH_Username : "MyK_Label_SC_KCH_Username",
    MyK_Label_SC_KCH_TransactionId : "MyK_Label_SC_KCH_TransactionId",
    MyK_Label_SC_KCH_TransactionDate : "MyK_Label_SC_KCH_TransactionDate",
    MyK_Label_SC_KCH_Amount : "MyK_Label_SC_KCH_Amount",
    MyK_Label_SC_KCH_ActionType : "MyK_Label_SC_KCH_ActionType",
    MyK_Label_DateOrTimeUTC: "MyK_Label_DateOrTimeUTC",
    MyK_Label_OperationStatus_SMRcalculated: "MyK_Label_OperationStatus_SMRcalculated",
    MyK_Label_ShoppingCart_Pickup_KomatsuShipping: "MyK_Label_ShoppingCart_Pickup_KomatsuShipping",
    MyK_Label_ShoppingCart_Pickup_KomatsuShipping_info: "MyK_Label_ShoppingCart_Pickup_KomatsuShipping_info",
    Myk_Info_SC_FAS_OrderingBranch_Info_Pickup_KomatsuShipping: "Myk_Info_SC_FAS_OrderingBranch_Info_Pickup_KomatsuShipping"
};
